import { Entity, WordpressPost } from '@benzinga/content-manager';

export const EntityMock: Entity = {
  affiliate_link: 'https://www.benzinga.com/go/1st-streit-office-offering/',
  attributes: [
    {
      label: 'Min. Investment',
      type: 'minInvestment',
      value: '$5,000',
    },
    {
      label: 'Target Return',
      type: 'targetReturn',
      value: '8 - 10%',
    },
    {
      label: 'SAT, GPA and More',
      type: 'examRequirements',
      value: 'Unlock with Compass',
    },
  ],
  description:
    'The ivy-covered campus of Princeton University, a private institution, is located in the quiet town of Princeton, New Jersey. Princeton was the first university to offer...',
  id: 0,
  image:
    'https://images.arrivedhomes.com/properties/151/74b1f661c08eccdb2d6a11262ccd0a34.jpg?optimize=medium&dpr=1&auto=webp&width=384',
  name: '1st Streit Office',
  owner: {
    id: 57641,
    image:
      'https://images.arrivedhomes.com/properties/151/74b1f661c08eccdb2d6a11262ccd0a34.jpg?optimize=medium&dpr=1&auto=webp&width=384',
    name: 'Streitwise',
    type: 'company',
    url: 'https://www.benzinga.com/alternative-investments/platforms/streitwise',
  },
  subtitle: null,
  tags: [
    {
      type: 'propertyType',
      value: 'Office',
    },
    {
      type: 'investorType',
      value: 'Non-Accredited',
    },
    {
      type: 'category',
      value: 'Non-Traded REIT',
    },
  ],
  type: 'Real Estate',
  url: 'https://www.benzinga.com/alternative-investments/listing/1st-streit-office-offering/',
};

export const OfferingsMock: Entity[] = [
  {
    affiliate_link: 'https://www.benzinga.com/go/10-federal-self-storage-3-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/10_Federal_Storage_Belmont_After_-25-1616783451836-1616783522448.png',
      investment_strategy: 'Fund',
      name: '10 Federal Self Storage 3',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/10-federal-fund-iii/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '3/30/2022',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Self-Storage',
      securities_offered: 'Equity',
      short_description:
        'An experienced, value-add self-storage investment company replicating a proven business plan by acquiring and converting facilities to automated operations using proprietary technologies.',
      sponsor: '10 Federal',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.09',
      target_equity_multiple: '1.5x',
    },
    description:
      'An experienced, value-add self-storage investment company replicating a proven business plan by acquiring and converting facilities to automated operations using proprietary technologies.',
    id: 1,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/10_Federal_Storage_Belmont_After_-25-1616783451836-1616783522448.png',
    name: '10 Federal Self Storage 3',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: '10-federal-self-storage-3',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Self-Storage',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-11T05:29:20.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/10-federal-self-storage-3',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: '1411 S. Flower MF Development',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 4,
    image: null,
    name: '1411 S. Flower MF Development',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: '1411-s-flower-mf-development',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/1411-s-flower-mf-development',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/1823-l-street-nw-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:40.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Exterior_1-1643228893377-1643231214821.png',
      investment_strategy: 'Core Plus',
      name: '1823 L Street NW',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/1823-l-street-nw/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '9,497,891',
      offering_close_date: '2/24/2022',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Washington D.C.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'A 99-unit, furnished apartment complex, 100% Master Leased to a $1.9B+ short-term rental provider. With a Walk Score of 97 and Transit Score of 99, 1823 L Street offers visitors close proximity to some of Downtown DC\u2019s most popular destinations.',
      sponsor: 'Urban Investment Partners',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.062',
      target_equity_multiple: '2.5x',
    },
    description:
      'A 99-unit, furnished apartment complex, 100% Master Leased to a $1.9B+ short-term rental provider. With a Walk Score of 97 and Transit Score of 99, 1823 L Street offers visitors close proximity to some of Downtown DC\u2019s most popular destinations.',
    id: 70,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Exterior_1-1643228893377-1643231214821.png',
    name: '1823 L Street NW',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: '1823-l-street-nw',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:24.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/1823-l-street-nw',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/1879-n-milwaukee-apartments-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:03.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3ROQzFrYzJNd01ERTROeTFvWkhJdFpXUnBkR1ZrTFRVME1IZ3pOamN0WTNKdmNDNXFjR2M9OjZiMjU1NmM0NzJlZDQ4YTI5NmQxMTJmYzZhMGNjMjJlLTYwNDY5MDdjODk5MzQ1M2I4MGQzZWJmOGEwMzI0N2Mw0&1642098002',
      investment_strategy: 'Core Plus',
      name: '1879 N Milwaukee Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link:
        'https://www.realcrowd.com/offerings/randolph-street-realty-capital-llc/1879-n-milwaukee-apartments',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Chicago, IL',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'An attractively priced, Class-A mixed-use apartment building in Chicago\u2019s Transit-Oriented Bucktown neighborhood.',
      sponsor: 'Randolph Street Realty Capital, LLC',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.057',
      target_equity_multiple: '1.65x',
    },
    description:
      'An attractively priced, Class-A mixed-use apartment building in Chicago\u2019s Transit-Oriented Bucktown neighborhood.',
    id: 49,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3ROQzFrYzJNd01ERTROeTFvWkhJdFpXUnBkR1ZrTFRVME1IZ3pOamN0WTNKdmNDNXFjR2M9OjZiMjU1NmM0NzJlZDQ4YTI5NmQxMTJmYzZhMGNjMjJlLTYwNDY5MDdjODk5MzQ1M2I4MGQzZWJmOGEwMzI0N2Mw0&1642098002',
    name: '1879 N Milwaukee Apartments',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: '1879-n-milwaukee-apartments',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:21.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/1879-n-milwaukee-apartments',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/1st-streit-office-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '1000-99999',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '8.5%',
      },
    ],
    created_at: '2022-03-30T18:31:42.000000Z',
    data: {
      home_offer_type: '',
      image: 'https://streitwise.com/wp-content/uploads/2018/11/exterior.png',
      investment_strategy: 'Growth, Income',
      name: '1st Streit Office',
      offer_investment_term: '5-9',
      offer_is_featured: null,
      offer_minimum_investment: '1000-99999',
      offer_offering_link: '',
      offer_open_to_non_accredited: 'Yes',
      offer_platform: 'Streitwise',
      offer_projected_return: '8.5%',
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Office',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Tryperion Partners, LLC',
      target_cash_yield_high: '0.1',
      target_cash_yield_low: '0.08',
      target_equity_multiple: '',
    },
    description: '',
    id: 98,
    image: 'https://streitwise.com/wp-content/uploads/2018/11/exterior.png',
    name: '1st Streit Office',
    owner: {
      id: 57641,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/01/28180747/streitwise-logo-text-1-768x143.png',
      name: 'Streitwise',
      slug: 'streitwise',
      url: 'https://www.benzinga.com/alternative-investments/platform/streitwise',
    },
    slug: '1st-streit-office',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Office',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Non-Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-30T18:31:42.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/1st-streit-office',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/286-lenox-ave-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '0-100',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '',
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: '',
      image: 'https://landwrights3.s3.us-east-2.amazonaws.com/assets/regal/Monopoly_Cover.jpg',
      investment_strategy: 'Core',
      name: '286 Lenox Ave',
      offer_investment_term: 'na',
      offer_is_featured: null,
      offer_minimum_investment: '0-100',
      offer_offering_link: 'https://invest.lex-markets.com/property/286-lenox-ave-5e8cc2b5a0bb88004208317d',
      offer_open_to_non_accredited: '',
      offer_platform: 'LEX-Markets',
      offer_projected_return: '',
      offering_amount: '2,150,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'New York, NY',
      property_type: 'Commercial',
      securities_offered: 'Equity',
      short_description:
        '286 Lenox is a recently constructed, fully-leased mixed-use office / retail building located on the corner of Lenox Avenue and 125th Street - a prominent retail corridor in the heart of Central Harlem within the Upper Manhattan submarket of New York City. The four-story building has 18,759 square feet of leasable space, and is currently occupied by three tenants: Wells Fargo Bank, N.A. (45% of rental revenue), Visiting Nurse Service of New York (37% of rental revenue), and Child Mind Institute, Inc (18% of rental revenue).',
      sponsor: 'Regal Acquisitions',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.043',
      target_equity_multiple: '2.1x',
    },
    description:
      '286 Lenox is a recently constructed, fully-leased mixed-use office / retail building located on the corner of Lenox Avenue and 125th Street - a prominent retail corridor in the heart of Central Harlem within the Upper Manhattan submarket of New York City. The four-story building has 18,759 square feet of leasable space, and is currently occupied by three tenants: Wells Fargo Bank, N.A. (45% of rental revenue), Visiting Nurse Service of New York (37% of rental revenue), and Child Mind Institute, Inc (18% of rental revenue).',
    id: 15,
    image: 'https://landwrights3.s3.us-east-2.amazonaws.com/assets/regal/Monopoly_Cover.jpg',
    name: '286 Lenox Ave',
    owner: {
      id: 167993,
      image: null,
      name: 'LEX-Markets',
      slug: 'lex-markets-2',
      url: 'https://www.benzinga.com/alternative-investments/platform/lex-markets-2',
    },
    slug: '286-lenox-ave',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Commercial',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:03.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/286-lenox-ave',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/305-huntland-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:48.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_1_Thumbnail_1_Email_1_Main_Email_2_Main-1644004833932-1644005017124.png',
      investment_strategy: 'Value-Add',
      name: '305 Huntland',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/305-huntland/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '7,100,000',
      offering_close_date: '3/4/2022',
      offering_launch_date: '2/17/2022',
      product_article: '',
      product_take: '',
      property_location: 'Austin, TX',
      property_type: 'Office',
      securities_offered: 'Equity',
      short_description:
        'An office in the Central Austin Office Market next to a popular 1.2M SF mixed-use destination and just 10 minutes from Downtown. The property, offering strong cash yield potential, will be partially converted to flexible office space.',
      sponsor: 'Expansive',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.152',
      target_equity_multiple: '2.8x',
    },
    description:
      'An office in the Central Austin Office Market next to a popular 1.2M SF mixed-use destination and just 10 minutes from Downtown. The property, offering strong cash yield potential, will be partially converted to flexible office space.',
    id: 73,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_1_Thumbnail_1_Email_1_Main_Email_2_Main-1644004833932-1644005017124.png',
    name: '305 Huntland',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: '305-huntland',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Office',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/305-huntland',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/8-federal-street-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:14.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Screen_Shot_2022-03-31_at_9.02.00_AM-1648742561794-1648742593607.png',
      investment_strategy: 'Value-Add',
      name: '8 Federal Street',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Billerica, MA',
      property_type: 'R&D',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Rhino Capital Advisors',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.071',
      target_equity_multiple: '1.6x',
    },
    description: '',
    id: 109,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Screen_Shot_2022-03-31_at_9.02.00_AM-1648742561794-1648742593607.png',
    name: '8 Federal Street',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: '8-federal-street',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'R&D',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:52.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/8-federal-street',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/cityvest-amroc-featured-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:35.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/09162430/image002.jpg',
      investment_strategy: 'Value-Add, Opportunistic',
      name: 'AmRoc Access Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.cityvest.com/realestateinvestments/amroc.html',
      offer_open_to_non_accredited: null,
      offer_platform: 'CityVest',
      offer_projected_return: null,
      offering_amount: '5,000,000',
      offering_close_date: '2/25/2022',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'AmRoc Premier Capital LLC',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.13',
      target_equity_multiple: '',
    },
    description: '',
    id: 68,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/09162430/image002.jpg',
    name: 'AmRoc Access Fund',
    owner: {
      id: 151074,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/05223253/CityVest-Logo-For-White-Background-768x87.png',
      name: 'CityVest',
      slug: 'cityvest',
      url: 'https://www.benzinga.com/alternative-investments/platform/cityvest',
    },
    slug: 'amroc-access-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T17:59:35.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/amroc-access-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/apollo-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:37.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://redswan.io/wp-content/uploads/2021/06/apollo-wpcf_410x308.jpg',
      investment_strategy: '',
      name: 'Apollo',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://redswan.io/real-estate-investment-united-states/',
      offer_open_to_non_accredited: null,
      offer_platform: 'RedSwan',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: '',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.1',
      target_equity_multiple: '2.17x',
    },
    description: '',
    id: 58,
    image: 'https://redswan.io/wp-content/uploads/2021/06/apollo-wpcf_410x308.jpg',
    name: 'Apollo',
    owner: {
      id: 168023,
      image: null,
      name: 'RedSwan',
      slug: 'redswan',
      url: 'https://www.benzinga.com/alternative-investments/platform/redswan',
    },
    slug: 'apollo',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:50:15.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/apollo',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/realtymogul/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:13.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/ascent_-_noon_w_logo.jpg?itok=sYVyvwp5',
      investment_strategy: 'Development',
      name: 'Ascent',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.realtymogul.com/investment-opportunity/1790929',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealtyMogul',
      offer_projected_return: null,
      offering_amount: '5,305,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Milwaukee, WI',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Ascent is a 25-story, 259-unit luxury mass timber building located in the heart of Milwaukee, WI. Construction is already 60% completed, and Investors have an opportunity to invest mid-construction at the original cost basis set forth at construction commencement in September',
      sponsor: 'New Land Enterprises',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.066',
      target_equity_multiple: '1.74x',
    },
    description:
      'Ascent is a 25-story, 259-unit luxury mass timber building located in the heart of Milwaukee, WI. Construction is already 60% completed, and Investors have an opportunity to invest mid-construction at the original cost basis set forth at construction commencement in September',
    id: 51,
    image:
      'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/ascent_-_noon_w_logo.jpg?itok=sYVyvwp5',
    name: 'Ascent',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'ascent',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:30.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/ascent',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/ashcroft-place-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:50.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Emma_-_labels_9_-1644612841562-1644612996454.png',
      investment_strategy: 'Development',
      name: 'Ashcroft Place',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/ashcroft-place/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '14,900,000',
      offering_close_date: '3/4/2022',
      offering_launch_date: '2/17/2022',
      product_article: '',
      product_take: '',
      property_location: 'Oswego, IL',
      property_type: 'Built-to-rent',
      securities_offered: 'Equity',
      short_description:
        'Development of a 178-unit build-to-rent community in Oswego, IL, an affluent town Southwest of Chicago attracting significant population growth due to its relative affordability, highly regarded school district, and numerous attractions.',
      sponsor: 'Lynd Living',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '1.7x',
    },
    description:
      'Development of a 178-unit build-to-rent community in Oswego, IL, an affluent town Southwest of Chicago attracting significant population growth due to its relative affordability, highly regarded school district, and numerous attractions.',
    id: 74,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Emma_-_labels_9_-1644612841562-1644612996454.png',
    name: 'Ashcroft Place',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'ashcroft-place',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Built-to-rent',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:33.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/ashcroft-place',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/ashford-point-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:24.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/ashfordpointe0016.jpg',
      investment_strategy: 'Growth, Income',
      name: 'Ashford Point',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealtyMogul',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Houston, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'LXMI Capital',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.032',
      target_equity_multiple: '1.59x',
    },
    description: '',
    id: 113,
    image:
      'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/ashfordpointe0016.jpg',
    name: 'Ashford Point',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'ashford-point',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:28:01.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/ashford-point',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Avon Marriott Beaver Creek Development - Op Zone',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 10,
    image: null,
    name: 'Avon Marriott Beaver Creek Development - Op Zone',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'avon-marriott-beaver-creek-development-op-zone',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/avon-marriott-beaver-creek-development-op-zone',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'BAM Multifamily Growth & Income Fund II',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 12,
    image: null,
    name: 'BAM Multifamily Growth & Income Fund II',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'bam-multifamily-growth-and-income-fund-ii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/bam-multifamily-growth-and-income-fund-ii',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/bluffview-towers-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:20:46.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Bluffview_Towers_Main_Image-1643150847329-1643150989321.png',
      investment_strategy: 'Value-Add',
      name: 'Bluffview Towers',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/bluffview-towers/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '15,520,262',
      offering_close_date: '2/15/2022',
      offering_launch_date: '1/21/2022',
      product_article: '',
      product_take: '',
      property_location: 'Dallas, TX',
      property_type: 'Office',
      securities_offered: 'Equity',
      short_description:
        'Bluffview Towers is a two-building, office asset located in the affluent neighborhood of Bluffview, just minutes from the highest-performing office center in the Dallas/Fort Worth Metroplex.',
      sponsor: 'Pillar Commercial Capital Management',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.073',
      target_equity_multiple: '1.5x',
    },
    description:
      'Bluffview Towers is a two-building, office asset located in the affluent neighborhood of Bluffview, just minutes from the highest-performing office center in the Dallas/Fort Worth Metroplex.',
    id: 43,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Bluffview_Towers_Main_Image-1643150847329-1643150989321.png',
    name: 'Bluffview Towers',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'bluffview-towers',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Office',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:01.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/bluffview-towers',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/boise-growth-portfolio-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:45.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/BoiseID-iStock-164080048-1644626463418-1644626502940.png',
      investment_strategy: 'Value-Add',
      name: 'Boise Growth Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/riverwalk-and-cw-moore-apartments/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '9,500,000',
      offering_close_date: '2/25/2022',
      offering_launch_date: '2/16/2022',
      product_article: '',
      product_take: '',
      property_location: 'Boisa, ID',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        '122-Unit, Multifamily, Value-Add portfolio in hyper-growth MSA of Boise, currently growing at 4x national average and #1 in population growth. Tenured, Repeat Sponsor - Roundhouse - Operates 1,800+ units in Boise at 94% portfolio occupancy.',
      sponsor: 'Roundhouse',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.037',
      target_equity_multiple: '1.6x',
    },
    description:
      '122-Unit, Multifamily, Value-Add portfolio in hyper-growth MSA of Boise, currently growing at 4x national average and #1 in population growth. Tenured, Repeat Sponsor - Roundhouse - Operates 1,800+ units in Boise at 94% portfolio occupancy.',
    id: 72,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/BoiseID-iStock-164080048-1644626463418-1644626502940.png',
    name: 'Boise Growth Portfolio',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'boise-growth-portfolio',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:28.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/boise-growth-portfolio',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/can-community-health-clinic-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:18.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/CAN_Community_Health_Renderings_Day_-_Copy-1647276339141-1647276409955.png',
      investment_strategy: 'Core Plus',
      name: 'CAN Community Health Clinic',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Denville, NJ',
      property_type: 'Medical Office',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Cypress West Partners',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.088',
      target_equity_multiple: '1.4x',
    },
    description: '',
    id: 111,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/CAN_Community_Health_Renderings_Day_-_Copy-1647276339141-1647276409955.png',
    name: 'CAN Community Health Clinic',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'can-community-health-clinic',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Medical Office',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:56.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/can-community-health-clinic',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/catalyst-access-fund-2-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-11T16:28:13.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://www.benzinga.com/wp-content/uploads/2022/04/image001.jpg',
      investment_strategy: 'Growth, Income',
      name: 'Catalyst Access Fund 2',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'CityVest',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article:
        'https://www.benzinga.com/real-estate/22/04/26571304/first-look-at-real-estate-investment-offering-for-catalyst-access-fund-with-20-25-targeted-net-annua',
      product_take:
        'A rare opportunity for individual investors to gain access to an institutional fund through this feeder fund structure',
      property_location: 'Sunbelt',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Colony Hills Capital',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.12',
      target_equity_multiple: '',
    },
    description: '',
    id: 118,
    image: 'https://www.benzinga.com/wp-content/uploads/2022/04/image001.jpg',
    name: 'Catalyst Access Fund 2',
    owner: {
      id: 151074,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/05223253/CityVest-Logo-For-White-Background-768x87.png',
      name: 'CityVest',
      slug: 'cityvest',
      url: 'https://www.benzinga.com/alternative-investments/platform/cityvest',
    },
    slug: 'catalyst-access-fund-2',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:28:13.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/catalyst-access-fund-2',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/centennial-tech-center-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:53.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Centennial_Tech_JLL_Guerilla_Capturing_013-1644441404069-1644441569233.png',
      investment_strategy: 'Core',
      name: 'Centennial Tech Center',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/centennial-tech-center/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '5.600.000',
      offering_close_date: '3/4/2022',
      offering_launch_date: '2/18/2022',
      product_article: '',
      product_take: '',
      property_location: 'Centennial, CO',
      property_type: 'Industrial',
      securities_offered: 'Equity',
      short_description:
        'A 100% leased, two-building industrial flex asset located in Centennial, Colorado. Sitting in the heart of Centennial\u2019s burgeoning industrial market, the Property represents a unique opportunity to acquire a highly sought-after asset type.',
      sponsor: 'The Bendetti Company',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.09',
      target_equity_multiple: '1.7x',
    },
    description:
      'A 100% leased, two-building industrial flex asset located in Centennial, Colorado. Sitting in the heart of Centennial\u2019s burgeoning industrial market, the Property represents a unique opportunity to acquire a highly sought-after asset type.',
    id: 75,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Centennial_Tech_JLL_Guerilla_Capturing_013-1644441404069-1644441569233.png',
    name: 'Centennial Tech Center',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'centennial-tech-center',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Industrial',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:35.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/centennial-tech-center',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/crowdstreet/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:23.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_3_Thumbnail_Email_2_Main-1643824035275-1643824203368.png',
      investment_strategy: 'Value-Add',
      name: 'Centrepoint Lake',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/centreport-lake/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '5,000,000',
      offering_close_date: '2/22/2022',
      offering_launch_date: '2/8/2022',
      product_article: '',
      product_take: '',
      property_location: 'Fort Worth, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        "A 2008-vintage, 452-unit, multifamily investment opportunity located in the Fort Worth suburb of Euless, sitting within close proximity to major economic drivers like DFW Int'l Airport and American Airlines HQ",
      sponsor: 'Marlin Spring',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.067',
      target_equity_multiple: '1.6x',
    },
    description:
      "A 2008-vintage, 452-unit, multifamily investment opportunity located in the Fort Worth suburb of Euless, sitting within close proximity to major economic drivers like DFW Int'l Airport and American Airlines HQ",
    id: 64,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_3_Thumbnail_Email_2_Main-1643824035275-1643824203368.png',
    name: 'Centrepoint Lake',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'centrepoint-lake',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:08.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/centrepoint-lake',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Congreso Park - Mexico City',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 25,
    image: null,
    name: 'Congreso Park - Mexico City',
    owner: {
      id: 161409,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/06094023/republic-logo-768x263.png',
      name: 'Republic',
      slug: 'republic',
      url: 'https://www.benzinga.com/alternative-investments/platform/republic',
    },
    slug: 'congreso-park-mexico-city',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/congreso-park-mexico-city',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'CrowdStreet Life Sciences & Healthcare Fund I',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 7,
    image: null,
    name: 'CrowdStreet Life Sciences & Healthcare Fund I',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'crowdstreet-life-sciences-and-healthcare-fund-i',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/crowdstreet-life-sciences-and-healthcare-fund-i',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'CrowdStreet Opportunistic Zone Fund III',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 23,
    image: null,
    name: 'CrowdStreet Opportunistic Zone Fund III',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'crowdstreet-opportunistic-zone-fund-iii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/crowdstreet-opportunistic-zone-fund-iii',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/crowdstreet-sunbelt-growth-fund-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:21.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Thumbnail_Image-1646331591414-1646331612578.png',
      investment_strategy: 'Growth, Income',
      name: 'CrowdStreet Sunbelt Growth Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Sunbelt',
      property_type: 'Diverse',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'CrowdStreet Advisors',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '1.8x-2.6x',
    },
    description: '',
    id: 112,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Thumbnail_Image-1646331591414-1646331612578.png',
    name: 'CrowdStreet Sunbelt Growth Fund',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'crowdstreet-sunbelt-growth-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Diverse',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-08T00:25:21.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/crowdstreet-sunbelt-growth-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/dallas-fort-worth-multi-family-equity-i-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:44.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://capi.myleasestar.com/v2/dimg/98280563/1536x723/98280563.jpg',
      investment_strategy: 'Value-Add',
      name: 'Dallas-Fort Worth Multi-Family Equity I',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.yieldstreet.com/offering/iCUPbg/dallas-fort-worth-multi-family-equity-i/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Yieldstreet',
      offer_projected_return: null,
      offering_amount: '11,700,000',
      offering_close_date: 'TBD',
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: 'Dallas, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Invest in an equity ownership of Sevona Avion, a 97% occupied multi-family property in Dallas-Fort Worth (DFW), Texas. The three story garden-style apartment complex was built in 2012 and is located equidistant from both Dallas and Fort Worth central business districts',
      sponsor: 'InterCapital Group',
      target_cash_yield_high: null,
      target_cash_yield_low: '0.06',
      target_equity_multiple: null,
    },
    description:
      'Invest in an equity ownership of Sevona Avion, a 97% occupied multi-family property in Dallas-Fort Worth (DFW), Texas. The three story garden-style apartment complex was built in 2012 and is located equidistant from both Dallas and Fort Worth central business districts',
    id: 61,
    image: 'https://capi.myleasestar.com/v2/dimg/98280563/1536x723/98280563.jpg',
    name: 'Dallas-Fort Worth Multi-Family Equity I',
    owner: {
      id: 85520,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/10/06091939/yieldstreet.png',
      name: 'Yieldstreet',
      slug: 'yieldstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/yieldstreet',
    },
    slug: 'dallas-fort-worth-multi-family-equity-i',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-01T04:21:45.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/dallas-fort-worth-multi-family-equity-i',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/dallas-fort-worth-multi-family-equity-i-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:16.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://capi.myleasestar.com/v2/dimg/98280563/1536x723/98280563.jpg',
      investment_strategy: 'Value-Add',
      name: 'Dallas-Fort Worth Multi-Family Equity I',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.yieldstreet.com/offering/iCUPbg/dallas-fort-worth-multi-family-equity-i/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Yieldstreet',
      offer_projected_return: null,
      offering_amount: '11,700,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Dallas, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Invest in an equity ownership of Sevona Avion, a 97% occupied multi-family property in Dallas-Fort Worth (DFW), Texas. The three story garden-style apartment complex was built in 2012 and is located equidistant from both Dallas and Fort Worth central business districts',
      sponsor: 'InterCapital Group',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.06',
      target_equity_multiple: '',
    },
    description:
      'Invest in an equity ownership of Sevona Avion, a 97% occupied multi-family property in Dallas-Fort Worth (DFW), Texas. The three story garden-style apartment complex was built in 2012 and is located equidistant from both Dallas and Fort Worth central business districts',
    id: 62,
    image: 'https://capi.myleasestar.com/v2/dimg/98280563/1536x723/98280563.jpg',
    name: 'Dallas-Fort Worth Multi-Family Equity I',
    owner: {
      id: 85520,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/10/06091939/yieldstreet.png',
      name: 'Yieldstreet',
      slug: 'yieldstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/yieldstreet',
    },
    slug: 'dallas-fort-worth-multi-family-equity-i-2',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:50:22.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/dallas-fort-worth-multi-family-equity-i-2',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/eastwood-oaks-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:32.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://redswan.io/wp-content/uploads/2021/08/eastwood_oaks-wpcf_410x308.jpg',
      investment_strategy: '',
      name: 'Eastwood Oaks',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://redswan.io/real-estate-investment-united-states/',
      offer_open_to_non_accredited: null,
      offer_platform: 'RedSwan',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: '',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.07',
      target_equity_multiple: '1.54x',
    },
    description: '',
    id: 56,
    image: 'https://redswan.io/wp-content/uploads/2021/08/eastwood_oaks-wpcf_410x308.jpg',
    name: 'Eastwood Oaks',
    owner: {
      id: 168023,
      image: null,
      name: 'RedSwan',
      slug: 'redswan',
      url: 'https://www.benzinga.com/alternative-investments/platform/redswan',
    },
    slug: 'eastwood-oaks',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:49.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/eastwood-oaks',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/elan-at-bluffview-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:33.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_1_Thumbnail_Email_1_Main-1643745634217-1643745816394.png',
      investment_strategy: 'Value-Add',
      name: 'Elan at Bluffview',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/elan-at-bluffview/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '12,000,000',
      offering_close_date: '2/23/2022',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Dallas, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'A short, 3-year-hold, multifamily value-add opportunity just miles from Southwest Airlines\u2019 HQ and the Dallas Medical District (37k jobs). The market\u2019s substantial supply/demand imbalance has produced great fundamentals for rentals.',
      sponsor: 'Red Summit Partners',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.044',
      target_equity_multiple: '1.6x',
    },
    description:
      'A short, 3-year-hold, multifamily value-add opportunity just miles from Southwest Airlines\u2019 HQ and the Dallas Medical District (37k jobs). The market\u2019s substantial supply/demand imbalance has produced great fundamentals for rentals.',
    id: 67,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_1_Thumbnail_Email_1_Main-1643745634217-1643745816394.png',
    name: 'Elan at Bluffview',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'elan-at-bluffview',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:17.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/elan-at-bluffview',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/fort-worth-medical-office-building-development-pad-site-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:06.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjbVZ1WkdWeWFXNW5MVFUwTUhnek5qY3RZM0p2Y0M1cWNHYz06NDQ1MjNkYTRjMTYxNDcwZDkyMjYyYmNlOGY3MDM4YzUtNDRjOTY0MDZhYmVhNDM5NWFiZTIzNTI3OGJmYWQyNmM1&1641848477',
      investment_strategy: 'Opportunistic, Development',
      name: 'Fort Worth Medical Office Building Development & Pad Site',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link:
        'https://www.realcrowd.com/offerings/the-woodmont-company/fort-worth-medical-office-building-development-pad-site',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Forth Worth, TX',
      property_type: 'Medical Office',
      securities_offered: 'Equity',
      short_description:
        'A development of a three story, 41,217 SF, medical building located in Southwest Fort Worth Medical District. Located in Fort Worth (DFW MSA), TX, adjacent to the Chisolm Trail Tollway with a 5 mile population around the site of over 208,000. In an underserved submarket where occupancy is over 95%.',
      sponsor: 'The Woodmont Company',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '1.68x',
    },
    description:
      'A development of a three story, 41,217 SF, medical building located in Southwest Fort Worth Medical District. Located in Fort Worth (DFW MSA), TX, adjacent to the Chisolm Trail Tollway with a 5 mile population around the site of over 208,000. In an underserved submarket where occupancy is over 95%.',
    id: 50,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjbVZ1WkdWeWFXNW5MVFUwTUhnek5qY3RZM0p2Y0M1cWNHYz06NDQ1MjNkYTRjMTYxNDcwZDkyMjYyYmNlOGY3MDM4YzUtNDRjOTY0MDZhYmVhNDM5NWFiZTIzNTI3OGJmYWQyNmM1&1641848477',
    name: 'Fort Worth Medical Office Building Development & Pad Site',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'fort-worth-medical-office-building-development-pad-site',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Medical Office',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:23.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/fort-worth-medical-office-building-development-pad-site',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-06T17:46:52.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://images.arrivedhomes.com/properties/133/06a5750b322e8d6348910c0bc0cb684e.jpg',
      investment_strategy: 'Growth, Income',
      name: 'Fractional Rental Property',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article:
        'https://www.benzinga.com/real-estate/22/04/26470416/private-deal-alert-fractional-investments-in-rental-properties-now-available',
      product_take: 'Probably the easiest way to invest in real estate while maintaining control over your investments',
      property_location: 'U.S.',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '0.07',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description: '',
    id: 106,
    image: 'https://images.arrivedhomes.com/properties/133/06a5750b322e8d6348910c0bc0cb684e.jpg',
    name: 'Fractional Rental Property',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'fractional-rental-property',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:47.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/fractional-rental-property',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/growth-fund-iv-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:20.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://origininvestments.com/wp-content/uploads/2022/01/Multifamily-Buidling-01.jpg',
      investment_strategy: 'Growth',
      name: 'Growth Fund IV',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://origininvestments.com/offerings/growth-fund-iv/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Origin Investments',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'The Fund will capitalize on changing demographic trends, participating in ground-up development projects in areas where there is not enough supply to meet growing demand.',
      sponsor: 'Origin Investments',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.07',
      target_equity_multiple: '1.8x',
    },
    description:
      'The Fund will capitalize on changing demographic trends, participating in ground-up development projects in areas where there is not enough supply to meet growing demand.',
    id: 54,
    image: 'https://origininvestments.com/wp-content/uploads/2022/01/Multifamily-Buidling-01.jpg',
    name: 'Growth Fund IV',
    owner: {
      id: 81374,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/08/02103832/OIP.jpg',
      name: 'Origin Investments',
      slug: 'origin-investments',
      url: 'https://www.benzinga.com/alternative-investments/platform/origin-investments',
    },
    slug: 'growth-fund-iv',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:49:58.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/growth-fund-iv',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '$25,000',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '14%',
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: 'Real Estate - Multifamily',
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/11/24120216/2-1637182215806-1637182849914-768x361.png',
      investment_strategy: null,
      name: 'CrowdStreet Growth Market Multifamily Fund',
      offer_investment_term: '7 years',
      offer_is_featured: null,
      offer_minimum_investment: '$25,000',
      offer_offering_link: 'https://benzinga.com/go/crowdstreet',
      offer_open_to_non_accredited: 'No',
      offer_platform: 'CrowdStreet',
      offer_projected_return: '14%',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: '',
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: '',
    id: 5,
    image:
      'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/11/24120216/2-1637182215806-1637182849914-768x361.png',
    name: 'CrowdStreet Growth Market Multifamily Fund',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'growth-market-multifamily-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2021-12-02T18:38:34.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/growth-market-multifamily-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/harbor-group-multi-family-eq-portfolio-ii-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://harborgroupint.com/templates/it_solo/custom/images/PortfolioQ42019/Buckeye%20Hickory%20Creek.jpg',
      investment_strategy: 'Value-Add',
      name: 'Harbor Group Multi-Family Eq Portfolio II',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.yieldstreet.com/offering/WIuixA/harbor-group-multi-family-eq-portfolio-ii/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Yieldstreet',
      offer_projected_return: null,
      offering_amount: '3,000,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Ohio',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Invest in an equity ownership of 19 well-maintained multi-family buildings that consist of 2,438 rental units with an average occupancy rate of 93%. The locations of the properties are expected to benefit from strong demographics, employment fundamentals and favorable supply-demand dynamics. As a result, each property is expected to provide investors with stable, current cash returns generated by rents, which are expected to increase year-on-year, and the opportunity for long-term capital appreciation.',
      sponsor: 'Harbor Group International',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description:
      'Invest in an equity ownership of 19 well-maintained multi-family buildings that consist of 2,438 rental units with an average occupancy rate of 93%. The locations of the properties are expected to benefit from strong demographics, employment fundamentals and favorable supply-demand dynamics. As a result, each property is expected to provide investors with stable, current cash returns generated by rents, which are expected to increase year-on-year, and the opportunity for long-term capital appreciation.',
    id: 33,
    image: 'https://harborgroupint.com/templates/it_solo/custom/images/PortfolioQ42019/Buckeye%20Hickory%20Creek.jpg',
    name: 'Harbor Group Multi-Family Eq Portfolio II',
    owner: {
      id: 85520,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/10/06091939/yieldstreet.png',
      name: 'Yieldstreet',
      slug: 'yieldstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/yieldstreet',
    },
    slug: 'harbor-group-multi-family-eq-portfolio-ii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:50:24.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/harbor-group-multi-family-eq-portfolio-ii',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Holiday Inn Resort Jekyll Island',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 38,
    image: null,
    name: 'Holiday Inn Resort Jekyll Island',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'holiday-inn-resort-jekyll-island',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/holiday-inn-resort-jekyll-island',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/incomeplus-fund-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://origininvestments.com/wp-content/uploads/2021/01/IPF-Offering-Tumbnail.jpg',
      investment_strategy: 'Growth, Income',
      name: 'IncomePlus Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://origininvestments.com/offerings/incomeplus-fund/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Origin Investments',
      offer_projected_return: null,
      offering_amount: '400,000,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: 'Tax-efficient passive income and appreciation.',
      sponsor: 'Origin Investments',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.0515',
      target_equity_multiple: '',
    },
    description: 'Tax-efficient passive income and appreciation.',
    id: 31,
    image: 'https://origininvestments.com/wp-content/uploads/2021/01/IPF-Offering-Tumbnail.jpg',
    name: 'IncomePlus Fund',
    owner: {
      id: 81374,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/08/02103832/OIP.jpg',
      name: 'Origin Investments',
      slug: 'origin-investments',
      url: 'https://www.benzinga.com/alternative-investments/platform/origin-investments',
    },
    slug: 'incomeplus-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:50:03.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/incomeplus-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/industrial-development-fund-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:43.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Thumbnail_Image3-1643848366485-1643848383325.png',
      investment_strategy: 'Growth',
      name: 'Industrial Development Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/crowdstreet-industrial-development-fund-i-llc/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '3/4/2022',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Industrial',
      securities_offered: 'Equity',
      short_description:
        'The Fund is designed to capitalize on record high demand for industrial assets nationwide. It will target development projects led by some of America\u2019s top sponsors in primary and supporting markets.',
      sponsor: 'CrowdStreet Advisors',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '1.7x-1.9x',
    },
    description:
      'The Fund is designed to capitalize on record high demand for industrial assets nationwide. It will target development projects led by some of America\u2019s top sponsors in primary and supporting markets.',
    id: 71,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Thumbnail_Image3-1643848366485-1643848383325.png',
    name: 'Industrial Development Fund',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'industrial-development-fund',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Industrial',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-11T05:30:18.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/industrial-development-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/inland-empire-industrial-cannabis-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T18:00:15.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_1_Thumbnail_Email_1_Main-1645115269159-1645115393009.png',
      investment_strategy: 'Core-Plus',
      name: 'Inland Empire Industrial Cannabis',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/inland-empire-industrial-cannabis-facility/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '5,250,000',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Perris, CA',
      property_type: 'Industrial',
      securities_offered: 'Equity',
      short_description:
        'A Class A, institutional quality industrial building located in the heart of Southern California\u2019s dynamic Inland Empire, 100% leased to two tenants in the cannabis industry with a WALT of 8 years.',
      sponsor: 'Post Investment Group',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.067',
      target_equity_multiple: '1.6x',
    },
    description:
      'A Class A, institutional quality industrial building located in the heart of Southern California\u2019s dynamic Inland Empire, 100% leased to two tenants in the cannabis industry with a WALT of 8 years.',
    id: 84,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_1_Thumbnail_Email_1_Main-1645115269159-1645115393009.png',
    name: 'Inland Empire Industrial Cannabis',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'inland-empire-industrial-cannabis',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Industrial',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:56.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/inland-empire-industrial-cannabis',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/jacksonville-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:35.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://redswan.io/wp-content/uploads/2021/06/jacksonville-wpcf_410x308.jpg',
      investment_strategy: '',
      name: 'Jacksonville',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://redswan.io/real-estate-investment-united-states/',
      offer_open_to_non_accredited: null,
      offer_platform: 'RedSwan',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: '',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.047',
      target_equity_multiple: '1.5x',
    },
    description: '',
    id: 57,
    image: 'https://redswan.io/wp-content/uploads/2021/06/jacksonville-wpcf_410x308.jpg',
    name: 'Jacksonville',
    owner: {
      id: 168023,
      image: null,
      name: 'RedSwan',
      slug: 'redswan',
      url: 'https://www.benzinga.com/alternative-investments/platform/redswan',
    },
    slug: 'jacksonville',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:51.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/jacksonville',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Junction Crossing',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 36,
    image: null,
    name: 'Junction Crossing',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'junction-crossing',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/junction-crossing',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '$25,000',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '25%+',
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: 'Real Estate - Multifamily',
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/14175221/image004.jpg',
      investment_strategy: null,
      name: 'KCAP Access Fund',
      offer_investment_term: '5 years',
      offer_is_featured: null,
      offer_minimum_investment: '$25,000',
      offer_offering_link: 'https://benzinga.com/go/cityvest',
      offer_open_to_non_accredited: 'No',
      offer_platform: 'CityVest',
      offer_projected_return: '25%+',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: '',
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: '',
    id: 19,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/14175221/image004.jpg',
    name: 'KCAP Access Fund',
    owner: {
      id: 151074,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/05223253/CityVest-Logo-For-White-Background-768x87.png',
      name: 'CityVest',
      slug: 'cityvest',
      url: 'https://www.benzinga.com/alternative-investments/platform/cityvest',
    },
    slug: 'kcap-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/kcap-fund',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Lakewood Manufactured Housing Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 3,
    image: null,
    name: 'Lakewood Manufactured Housing Portfolio',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'lakewood-manufactured-housing-portfolio',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/lakewood-manufactured-housing-portfolio',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Latitude at West Ashley Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 6,
    image: null,
    name: 'Latitude at West Ashley Apartments',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'latitude-at-west-ashley-apartments',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/latitude-at-west-ashley-apartments',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/realcrowd-lurin/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:20:53.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjSEpwYldGeWVYQm9iM1J2TFRVME1IZ3pOamN0WTNKdmNDNXFjR2M9OjUyMGI1ZDc3OGQ3MDQ3NGRhYjAwMWZkYzA5ZWE4YTE4LWNlMzllZWE1NjZlYjQwZTJiMDczNzNjMDNjM2ZiYjE40&1641938080',
      investment_strategy: 'Value-Add',
      name: 'LURIN: Villas at Tenison Park',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.realcrowd.com/offerings/lurin/lurin-villas-at-tenison-park-dallas-tx',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Dallas, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'A value-add multifamily investment opportunity in Dallas, one of the fastest growing and best performing markets for multifamily housing in the country. LURIN plans to use its in-house Construction and Property Management teams to extensively renovate and reposition the asset. - Jon Venetos, LURIN',
      sponsor: 'LURIN',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.0428',
      target_equity_multiple: '2.03x',
    },
    description:
      'A value-add multifamily investment opportunity in Dallas, one of the fastest growing and best performing markets for multifamily housing in the country. LURIN plans to use its in-house Construction and Property Management teams to extensively renovate and reposition the asset. - Jon Venetos, LURIN',
    id: 45,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjSEpwYldGeWVYQm9iM1J2TFRVME1IZ3pOamN0WTNKdmNDNXFjR2M9OjUyMGI1ZDc3OGQ3MDQ3NGRhYjAwMWZkYzA5ZWE4YTE4LWNlMzllZWE1NjZlYjQwZTJiMDczNzNjMDNjM2ZiYjE40&1641938080',
    name: 'LURIN: Villas at Tenison Park',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'lurin-villas-at-tenison-park',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:11.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/lurin-villas-at-tenison-park',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/lxmi-copper-cove-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:27.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/coppercove0022.jpg?',
      investment_strategy: 'Growth, Income',
      name: 'LXMI Copper Cove',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealtyMogul',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Houston, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'LXMI Capital',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.035',
      target_equity_multiple: '1.63x',
    },
    description: '',
    id: 114,
    image:
      'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/coppercove0022.jpg?',
    name: 'LXMI Copper Cove',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'lxmi-copper-cove',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:28:03.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/lxmi-copper-cove',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/marchwood-apartments-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T00:30:25.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RNREV0WlhoMFpYSnBiM0l4TFRVME1IZ3pOamN0WTNKdmNDNXFjR2M9Ojg4MzA3OTQxY2Q2YjRkZTI4NTljODk1YjliNTI2MzZhLWM0OGMyMDMxYjA2NzQ4MDY4MjhkZDhhZjY1YjBiMTZj0&1645037757',
      investment_strategy: 'Value-Add',
      name: 'Marchwood Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.realcrowd.com/offerings/strategic-realty-holdings/marchwood-apartments',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Philadelphia, PA',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Marchwood Apartments presents a rare opportunity to acquire, at a significant discount, a prime value-add asset candidate in historical Germantown, Philadelphia.',
      sponsor: 'Strategic Realty Holdings',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.04',
      target_equity_multiple: '1.9x',
    },
    description:
      'Marchwood Apartments presents a rare opportunity to acquire, at a significant discount, a prime value-add asset candidate in historical Germantown, Philadelphia.',
    id: 86,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RNREV0WlhoMFpYSnBiM0l4TFRVME1IZ3pOamN0WTNKdmNDNXFjR2M9Ojg4MzA3OTQxY2Q2YjRkZTI4NTljODk1YjliNTI2MzZhLWM0OGMyMDMxYjA2NzQ4MDY4MjhkZDhhZjY1YjBiMTZj0&1645037757',
    name: 'Marchwood Apartments',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'marchwood-apartments',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-16T00:30:25.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/marchwood-apartments',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/miami-industrial-portfolio-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:38.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RhVzFoWjJVd01ERXROVFF3ZURNMk55MWpjbTl3TG5CdVp3PT06YTU4Zjk0NmFmODYyNDVlYmIzOTdiMTlkYzhiMGFiZGMtMDJlMTJkZGM0YzIxNGUwNTg1MDIxN2QyNDA2NWFjNzk1&1644191121',
      investment_strategy: 'Value-Add',
      name: 'Miami Industrial Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Miami, FL',
      property_type: 'Industrial',
      securities_offered: 'Equity',
      short_description:
        "The O'Donnell Group is strategically acquiring five (5) last-mile value-add industrial assets totaling over 250,000 square feet at a significant discount to replacement cost. With tenants on short-term leases, and in place rents 30% below market, The O\u2019Donnell Group sees tremendous upside potential through investing in capital expenditure and realizing market rate rents.",
      sponsor: "The O'Donnell Group",
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '1.52x',
    },
    description:
      "The O'Donnell Group is strategically acquiring five (5) last-mile value-add industrial assets totaling over 250,000 square feet at a significant discount to replacement cost. With tenants on short-term leases, and in place rents 30% below market, The O\u2019Donnell Group sees tremendous upside potential through investing in capital expenditure and realizing market rate rents.",
    id: 69,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RhVzFoWjJVd01ERXROVFF3ZURNMk55MWpjbTl3TG5CdVp3PT06YTU4Zjk0NmFmODYyNDVlYmIzOTdiMTlkYzhiMGFiZGMtMDJlMTJkZGM0YzIxNGUwNTg1MDIxN2QyNDA2NWFjNzk1&1644191121',
    name: 'Miami Industrial Portfolio',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'miami-industrial-portfolio',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Industrial',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:22.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/miami-industrial-portfolio',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Millenium Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 37,
    image: null,
    name: 'Millenium Apartments',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'millenium-apartments',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/millenium-apartments',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Minnesota Last Mile Industrial Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 39,
    image: null,
    name: 'Minnesota Last Mile Industrial Portfolio',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'minnesota-last-mile-industrial-portfolio',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/minnesota-last-mile-industrial-portfolio',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: 'na',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '9.8%',
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: 'Real Estate - Diversified',
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/08/04141315/MRI.81683e57.jpg',
      investment_strategy: '',
      name: 'Mogul REIT I',
      offer_investment_term: 'na',
      offer_is_featured: null,
      offer_minimum_investment: 'na',
      offer_offering_link: 'https://benzinga.com/go/realtymogul',
      offer_open_to_non_accredited: 'Yes',
      offer_platform: 'RealtyMogul',
      offer_projected_return: '9.8%',
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: null,
      product_take: '',
      property_location: '',
      property_type: '',
      securities_offered: '',
      short_description: '',
      sponsor: '',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '',
    },
    description: '',
    id: 16,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/08/04141315/MRI.81683e57.jpg',
    name: 'Mogul REIT I',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'mogulreit-i',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: '',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Non-Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2021-12-02T18:38:34.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/mogulreit-i',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '0-100',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '16%',
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: 'Real Estate - Multifamily',
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/15173415/the_orion_-_tile_png-768x412.png',
      investment_strategy: null,
      name: 'MogulREIT II',
      offer_investment_term: 'na',
      offer_is_featured: null,
      offer_minimum_investment: '0-100',
      offer_offering_link: 'https://benzinga.com/go/realtymogul',
      offer_open_to_non_accredited: 'Yes',
      offer_platform: 'RealtyMogul',
      offer_projected_return: '16%',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: '',
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: '',
    id: 17,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/15173415/the_orion_-_tile_png-768x412.png',
    name: 'MogulREIT II',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'mogulreit-ii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Non-Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2021-12-02T18:38:34.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/mogulreit-ii',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/multi-family-portfolio-fund-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:30.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/31140131/brandon-griggs-wR11KBaB86U-unsplash-1.jpg',
      investment_strategy: 'Value-Add, Growth, Income',
      name: 'Multi-Family Portfolio Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://invest.caltierrealtyfund.com/offering/ctrfund1/details',
      offer_open_to_non_accredited: null,
      offer_platform: 'Caltier Realty',
      offer_projected_return: null,
      offering_amount: '50,000,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article:
        'https://www.benzinga.com/real-estate/22/03/26169582/arrived-homes-expands-into-new-market-with-latest-offering-for-fractionalized-rental-property-invest',
      product_take:
        "The CalTier Portfolio Fund aims to invest into existing class 'B & C' multi-family assets in the West & South Western United States. These assets will have an identified 'value-add' aspect to them in that if they are acquired and then improved the rents can be increased to meet the local economic standard.",
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        "The CalTier Portfolio Fund aims to invest into existing class 'B & C' multi-family assets in the West & South Western United States. These assets will have an identified 'value-add' aspect to them in that if they are acquired and then improved the rents can be increased to meet the local economic standard.",
      sponsor: 'Caltier Realty',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.08',
      target_equity_multiple: '',
    },
    description:
      "The CalTier Portfolio Fund aims to invest into existing class 'B & C' multi-family assets in the West & South Western United States. These assets will have an identified 'value-add' aspect to them in that if they are acquired and then improved the rents can be increased to meet the local economic standard.",
    id: 55,
    image:
      'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/31140131/brandon-griggs-wR11KBaB86U-unsplash-1.jpg',
    name: 'Multi-Family Portfolio Fund',
    owner: {
      id: 168020,
      image: null,
      name: 'Caltier Realty',
      slug: 'caltier-realty',
      url: 'https://www.benzinga.com/alternative-investments/platform/caltier-realty',
    },
    slug: 'multi-family-portfolio-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:50:08.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/multi-family-portfolio-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/multifamily-credit-fund-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://origininvestments.com/wp-content/uploads/2021/02/MCF-Offering-Tumnbnail.jpg',
      investment_strategy: 'Income',
      name: 'Multifamily Credit Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://origininvestments.com/offerings/multifamily-credit-fund/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Origin Investments',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Debt',
      short_description:
        'This real estate credit fund invests in conservatively leveraged Freddie Mac bonds that are backed by cash flowing and geographically diversified multifamily loans.',
      sponsor: 'Origin Investments',
      target_cash_yield_high: '0.08',
      target_cash_yield_low: '0.06',
      target_equity_multiple: '1.6x',
    },
    description:
      'This real estate credit fund invests in conservatively leveraged Freddie Mac bonds that are backed by cash flowing and geographically diversified multifamily loans.',
    id: 32,
    image: 'https://origininvestments.com/wp-content/uploads/2021/02/MCF-Offering-Tumnbnail.jpg',
    name: 'Multifamily Credit Fund',
    owner: {
      id: 81374,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/08/02103832/OIP.jpg',
      name: 'Origin Investments',
      slug: 'origin-investments',
      url: 'https://www.benzinga.com/alternative-investments/platform/origin-investments',
    },
    slug: 'multifamily-credit-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:44.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/multifamily-credit-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/multifamily-opportunity-fund-iii-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T18:00:13.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/the-russell-gallery36.jpg-1644439195183-1644439222798.png',
      investment_strategy: 'Value-Add',
      name: 'Multifamily Opportunity Fund III',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/multifamily-opportunity-fund-iii',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '50,000,000',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'A Fund, currently invested in six properties, targeting value-add and opportunistic strategies within existing middle market multifamily assets in Western and Sunbelt states.',
      sponsor: 'Trion Properties',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.08',
      target_equity_multiple: '1.6x-1.9x',
    },
    description:
      'A Fund, currently invested in six properties, targeting value-add and opportunistic strategies within existing middle market multifamily assets in Western and Sunbelt states.',
    id: 83,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/the-russell-gallery36.jpg-1644439195183-1644439222798.png',
    name: 'Multifamily Opportunity Fund III',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'multifamily-opportunity-fund-iii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T18:00:13.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/multifamily-opportunity-fund-iii',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/myrtle-beach-hampton-inn-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-23T18:15:48.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_1_Thumbnail_Email_1_Main-1647383111855-1647383126454.png',
      investment_strategy: 'Value-Add',
      name: 'Myrtle Beach Hampton Inn',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/myrtle-beach-hampton-inn/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '$5,685,947',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: 'https://www.benzinga.com/node/26262384',
      product_take:
        "This property will likely outperform the sponsor's conservative projections based on the industry's strong recovery and the sponsor's successful track record",
      property_location: 'Myrtle Beach, SC',
      property_type: 'Hospitality',
      securities_offered: 'Equity',
      short_description:
        'A 121-key Hampton Inn located in the heart of Myrtle Beach, a premier drive-to destination that recorded the strongest hotel performance recovery of any top market in the country as of 2021.',
      sponsor: 'Suncroft',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.2',
      target_equity_multiple: '2.1x',
    },
    description:
      'A 121-key Hampton Inn located in the heart of Myrtle Beach, a premier drive-to destination that recorded the strongest hotel performance recovery of any top market in the country as of 2021.',
    id: 94,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_1_Thumbnail_Email_1_Main-1647383111855-1647383126454.png',
    name: 'Myrtle Beach Hampton Inn',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'myrtle-beach-hampton-inn',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Hospitality',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:19.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/myrtle-beach-hampton-inn',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'New Braunfels North',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 35,
    image: null,
    name: 'New Braunfels North',
    owner: {
      id: 165188,
      image: null,
      name: 'Fairway America',
      slug: 'fairway-america',
      url: 'https://www.benzinga.com/alternative-investments/platform/fairway-america',
    },
    slug: 'new-braunfels-north',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/new-braunfels-north',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'New Era MEdical Investment Fund IV',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 2,
    image: null,
    name: 'New Era MEdical Investment Fund IV',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'new-era-medical-investment-fund-iv',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/new-era-medical-investment-fund-iv',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'North Carolina Beach Rental Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 24,
    image: null,
    name: 'North Carolina Beach Rental Portfolio',
    owner: {
      id: 161409,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/06094023/republic-logo-768x263.png',
      name: 'Republic',
      slug: 'republic',
      url: 'https://www.benzinga.com/alternative-investments/platform/republic',
    },
    slug: 'north-carolina-beach-rental-portfolio',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/north-carolina-beach-rental-portfolio',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/north-shore-boston-multi-family-equity-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://cdn.benzinga.com/files/imagecache/story_image_685x375C/images/story/2012/eliot-multifamily-yieldstreet.jpg',
      investment_strategy: 'Core, Value-Add',
      name: 'North Shore Boston Multi-Family Equity',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.yieldstreet.com/offering/s4VzPw/north-shore-boston-multi-family-equity-/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Yieldstreet',
      offer_projected_return: null,
      offering_amount: '24,750,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Boston, MA',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'nvest in an equity ownership of Eliot on the Ocean, a 94% occupied multi-family mid-rise apartment complex built in 2016 along Revere Beach in Boston\u2019s North Shore suburb.',
      sponsor: 'Invictus Real Estate Partners',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.04',
      target_equity_multiple: '',
    },
    description:
      'nvest in an equity ownership of Eliot on the Ocean, a 94% occupied multi-family mid-rise apartment complex built in 2016 along Revere Beach in Boston\u2019s North Shore suburb.',
    id: 34,
    image:
      'https://cdn.benzinga.com/files/imagecache/story_image_685x375C/images/story/2012/eliot-multifamily-yieldstreet.jpg',
    name: 'North Shore Boston Multi-Family Equity',
    owner: {
      id: 85520,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/10/06091939/yieldstreet.png',
      name: 'Yieldstreet',
      slug: 'yieldstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/yieldstreet',
    },
    slug: 'north-shore-boston-multi-family-equity',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T17:59:28.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/north-shore-boston-multi-family-equity',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'NYC Opportunity Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 26,
    image: null,
    name: 'NYC Opportunity Fund',
    owner: {
      id: 161409,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/06094023/republic-logo-768x263.png',
      name: 'Republic',
      slug: 'republic',
      url: 'https://www.benzinga.com/alternative-investments/platform/republic',
    },
    slug: 'nyc-opportunity-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/nyc-opportunity-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/farmtogether/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-11T16:28:10.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://www.benzinga.com/wp-content/uploads/2022/04/pistachio-g2bdd86fbe_1920.jpg',
      investment_strategy: 'Growth, Income',
      name: 'Oak Ridge Pistachio Orchard',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'FarmTogether',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Kern County, CA',
      property_type: 'Farmland',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'FarmTogether Management',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.076',
      target_equity_multiple: '2.5x',
    },
    description: '',
    id: 117,
    image: 'https://www.benzinga.com/wp-content/uploads/2022/04/pistachio-g2bdd86fbe_1920.jpg',
    name: 'Oak Ridge Pistachio Orchard',
    owner: {
      id: 67335,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/04/29101331/Screen-Shot-2020-04-29-at-10.02.28-AM.png',
      name: 'FarmTogether',
      slug: 'farmtogether',
      url: 'https://www.benzinga.com/alternative-investments/platform/farmtogether',
    },
    slug: 'oak-ridge-pistachio-orchard',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Farmland',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:28:10.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/oak-ridge-pistachio-orchard',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/one-river-header/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_2_Email_1_Side_-1639667943090-1639668006343.png',
      investment_strategy: 'Development',
      name: 'One River',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/one-river/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '23,000,000',
      offering_close_date: '2/8/2022',
      offering_launch_date: '12/10/2022',
      product_article: '',
      product_take: '',
      property_location: 'Ft Lauderdale, FL',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Luxury multifamily development on one of Fort Lauderdale\u2019s last developable sites within the affluent Rio Vista neighborhood, nearby fine dining, private schools, golf courses, yacht clubs, shopping, and more.',
      sponsor: 'OKO Group',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '2.2x',
    },
    description:
      'Luxury multifamily development on one of Fort Lauderdale\u2019s last developable sites within the affluent Rio Vista neighborhood, nearby fine dining, private schools, golf courses, yacht clubs, shopping, and more.',
    id: 22,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Carousel_2_Email_1_Side_-1639667943090-1639668006343.png',
    name: 'One River',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'one-river',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:25.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/one-river',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/onewall-co-investment-fund-i-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:01.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMV2RoYkd4bGNua3RjMkl6TFRJd01EQjRNakF3TUMxdFlYZ3VhbkJuOmMzOTA3NzBkYjZlYjRlMTk5MzBlMzJlZjZiZjlmMWU3LTk0ODVlNTA5MWNhZDQ2YTQ4ZTZhMDQwMTllMTIyYTdl0&1641235684',
      investment_strategy: 'Value-Add',
      name: 'OneWall Co-Investment Fund I',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.realcrowd.com/offerings/onewall-communities/onewall-co-investment-fund-i',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Multifamily value-add workforce housing fund offering individuals access to institutional deals that generate immediate cash-on-cash returns and benefit from the supply/demand imbalance for naturally affordable market rate apartments in the Northeast/Mid-Atlantic U.S.',
      sponsor: 'OneWall Communities',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.08',
      target_equity_multiple: '1.9x',
    },
    description:
      'Multifamily value-add workforce housing fund offering individuals access to institutional deals that generate immediate cash-on-cash returns and benefit from the supply/demand imbalance for naturally affordable market rate apartments in the Northeast/Mid-Atlantic U.S.',
    id: 48,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMV2RoYkd4bGNua3RjMkl6TFRJd01EQjRNakF3TUMxdFlYZ3VhbkJuOmMzOTA3NzBkYjZlYjRlMTk5MzBlMzJlZjZiZjlmMWU3LTk0ODVlNTA5MWNhZDQ2YTQ4ZTZhMDQwMTllMTIyYTdl0&1641235684',
    name: 'OneWall Co-Investment Fund I',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'onewall-co-investment-fund-i',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:49:39.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/onewall-co-investment-fund-i',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Origo Cold Storage Industrial',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 29,
    image: null,
    name: 'Origo Cold Storage Industrial',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'origo-cold-storage-industrial',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/origo-cold-storage-industrial',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '$50,000',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '28.45%',
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: 'Real Estate - Multifamily',
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/11/11114750/real-crowd-palisades-768x544.jpg',
      investment_strategy: null,
      name: 'RealCrowd Palisades at Pleasant Crossing',
      offer_investment_term: '3 years',
      offer_is_featured: null,
      offer_minimum_investment: '$50,000',
      offer_offering_link: 'https://www.benzinga.com/go/realcrowd-palisades',
      offer_open_to_non_accredited: 'No',
      offer_platform: 'RealCrowd',
      offer_projected_return: '28.45%',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 11,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/11/11114750/real-crowd-palisades-768x544.jpg',
    name: 'RealCrowd Palisades at Pleasant Crossing',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'palisades-at-pleasant-crossing',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2021-12-02T18:38:34.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/palisades-at-pleasant-crossing',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/parchaus-build-to-rent-portfolio-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-23T18:15:53.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Photo_Oct_11_9_34_00_AM-1638805756849-1638806240431.png',
      investment_strategy: 'Development',
      name: 'parcHaus Build-to-Rent Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/btr-fund/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '$50,000,000',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Texas',
      property_type: 'Built-to-rent',
      securities_offered: 'Equity',
      short_description:
        'An equity investment in a Portfolio of Class-A Build-To-Rent Communities, a high-demand asset class, diversified across the primary MSA\u2019s in Texas, including Dallas/Fort Worth, Austin and Houston.',
      sponsor: 'Provident Realty Advisors',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.0622',
      target_equity_multiple: '1.9x-2.2x',
    },
    description:
      'An equity investment in a Portfolio of Class-A Build-To-Rent Communities, a high-demand asset class, diversified across the primary MSA\u2019s in Texas, including Dallas/Fort Worth, Austin and Houston.',
    id: 96,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Photo_Oct_11_9_34_00_AM-1638805756849-1638806240431.png',
    name: 'parcHaus Build-to-Rent Portfolio',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'parchaus-build-to-rent-portfolio',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Built-to-rent',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-23T18:15:53.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/parchaus-build-to-rent-portfolio',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '$25,000',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '23.9%',
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: 'Real Estate - Multifamily',
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/20152723/crowdstreet-park-place-768x361.jpg',
      investment_strategy: null,
      name: 'Park Place Nashville',
      offer_investment_term: '6 years',
      offer_is_featured: null,
      offer_minimum_investment: '$25,000',
      offer_offering_link: 'https://benzinga.com/go/crowdstreet-park-place-nashville',
      offer_open_to_non_accredited: 'No',
      offer_platform: 'CrowdStreet',
      offer_projected_return: '23.9%',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: '',
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: '',
    id: 21,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/20152723/crowdstreet-park-place-768x361.jpg',
    name: 'Park Place Nashville',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'park-place-nashville',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/park-place-nashville',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/private-equity-reit-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T18:00:10.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Screen_Shot_2022-02-15_at_2.45.31_PM-1644958055241-1644958076745.png',
      investment_strategy: 'Growth, Income',
      name: 'Private Equity REIT',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/invexp/properties/all',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Commercial',
      securities_offered: 'Equity',
      short_description:
        'Providing accredited investors with a diversified portfolio of growth-oriented, private commercial real estate deals focused on capital appreciation.',
      sponsor: 'CrowdStreet Advisors',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '1.8x-2.3x',
    },
    description:
      'Providing accredited investors with a diversified portfolio of growth-oriented, private commercial real estate deals focused on capital appreciation.',
    id: 82,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Screen_Shot_2022-02-15_at_2.45.31_PM-1644958055241-1644958076745.png',
    name: 'Private Equity REIT',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'private-equity-reit',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Commercial',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T18:00:10.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/private-equity-reit',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/qoz-fund-ii-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://origininvestments.com/wp-content/uploads/2021/09/Origin-QOZ-Fund-II-Offering-Tumnbnail.jpg',
      investment_strategy: 'Growth',
      name: 'QOZ Fund II',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://origininvestments.com/offerings/qoz-fund-ii/',
      offer_open_to_non_accredited: null,
      offer_platform: 'Origin Investments',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'The Qualified Opportunity Zone program was created under the Tax Cuts and Jobs Act of 2017 to incentivize real estate investment in targeted communities in need of economic development, called QOZ\u2019s. It provides significant tax advantages to investors who invest with capital gains. Some examples of assets that can be sold and the proceeds reinvested in a QOZ are stocks, real estate, a private business, precious metals, cryptocurrencies and art. ',
      sponsor: 'Origin Investments',
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '2.25x - 2.5x',
    },
    description:
      'The Qualified Opportunity Zone program was created under the Tax Cuts and Jobs Act of 2017 to incentivize real estate investment in targeted communities in need of economic development, called QOZ\u2019s. It provides significant tax advantages to investors who invest with capital gains. Some examples of assets that can be sold and the proceeds reinvested in a QOZ are stocks, real estate, a private business, precious metals, cryptocurrencies and art. ',
    id: 30,
    image: 'https://origininvestments.com/wp-content/uploads/2021/09/Origin-QOZ-Fund-II-Offering-Tumnbnail.jpg',
    name: 'QOZ Fund II',
    owner: {
      id: 81374,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/08/02103832/OIP.jpg',
      name: 'Origin Investments',
      slug: 'origin-investments',
      url: 'https://www.benzinga.com/alternative-investments/platform/origin-investments',
    },
    slug: 'qoz-fund-ii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:40.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/qoz-fund-ii',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Rainbow Cannabis Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 20,
    image: null,
    name: 'Rainbow Cannabis Fund',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'rainbow-cannabis-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/rainbow-cannabis-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/crowdstreet-rainbow-cannabis-fund-ii/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:20:48.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/My_Post-1638215153874-1638215242423.png',
      investment_strategy: 'Fund',
      name: 'Rainbow Cannabis Fund II',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/rainbow-cannabis-fund-ii/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '25,000,000',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Cannabis',
      securities_offered: 'Equity',
      short_description:
        'An equity & debt fund capitalizing on one of the fastest growing industries by solving the lack of capital available to retail and industrial cannabis operators',
      sponsor: 'Rainbow Realty Group',
      target_cash_yield_high: '0.1',
      target_cash_yield_low: '0.07',
      target_equity_multiple: '1.53x',
    },
    description:
      'An equity & debt fund capitalizing on one of the fastest growing industries by solving the lack of capital available to retail and industrial cannabis operators',
    id: 44,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/My_Post-1638215153874-1638215242423.png',
    name: 'Rainbow Cannabis Fund II',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'rainbow-cannabis-fund-ii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Cannabis',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:09.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/rainbow-cannabis-fund-ii',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/realtymogul/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:18.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realtymogul.com/sites/default/files/styles/private_placement_carousel/public/_mg_0132_0.jpg?itok=psrdaEFR',
      investment_strategy: 'Growth',
      name: 'RealtyMogul Apartment Growth REIT',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.realtymogul.com/investment-options/the-apartment-growth-reit',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealtyMogul',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'The Apartment Growth REIT is a public, non-traded REIT that invests in apartment buildings located in resilient markets that can offer current income and solid growth potential. The REIT\u2019s primary objective is to realize capital appreciation in the value of its investments over the long term through the renovation and repositioning of the multifamily properties as well as to pay attractive and stable cash distributions to stockholders.',
      sponsor: 'RM Adviser',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.045',
      target_equity_multiple: '',
    },
    description:
      'The Apartment Growth REIT is a public, non-traded REIT that invests in apartment buildings located in resilient markets that can offer current income and solid growth potential. The REIT\u2019s primary objective is to realize capital appreciation in the value of its investments over the long term through the renovation and repositioning of the multifamily properties as well as to pay attractive and stable cash distributions to stockholders.',
    id: 53,
    image:
      'https://www.realtymogul.com/sites/default/files/styles/private_placement_carousel/public/_mg_0132_0.jpg?itok=psrdaEFR',
    name: 'RealtyMogul Apartment Growth REIT',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'realtymogul-apartment-growth-reit',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:35.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/realtymogul-apartment-growth-reit',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/realtymogul/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:15.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realtymogul.com/sites/default/files/styles/private_placement_carousel/public/kings_landing-29_0.jpg?itok=Tkeue8qi',
      investment_strategy: 'Income',
      name: 'RealtyMogul Income REIT',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.realtymogul.com/investment-options/the-income-reit',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealtyMogul',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Diverse',
      securities_offered: 'Equity',
      short_description:
        'The RealtyMogul Income REIT (Real Estate Investment Trust) is a public, non-traded REIT making equity and debt investments in commercial real estate properties diversified by investment type, geography and property type.',
      sponsor: 'RM Adviser',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.06',
      target_equity_multiple: '',
    },
    description:
      'The RealtyMogul Income REIT (Real Estate Investment Trust) is a public, non-traded REIT making equity and debt investments in commercial real estate properties diversified by investment type, geography and property type.',
    id: 52,
    image:
      'https://www.realtymogul.com/sites/default/files/styles/private_placement_carousel/public/kings_landing-29_0.jpg?itok=Tkeue8qi',
    name: 'RealtyMogul Income REIT',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'realtymogul-income-reit',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Diverse',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:33.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/realtymogul-income-reit',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/realcrowd-reliant/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:20:56.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjbVZzYVdGdWRDMW9aV0ZrWlhJdGNtVmhiR055YjNka0xXNWxkeTAxTkRBdWFuQm46YzJiZGZkY2JkOWI1NDcxMWFlYmVhMmZiMjAxYzcxYWQtOTBlN2Y2NmJjY2RmNDQzM2FmNWZlZTJkNGJhNDRjZTQ1&1642542703',
      investment_strategy: 'Value-Add, Core',
      name: 'Reliant Self-Storage Fund III',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link:
        'https://www.realcrowd.com/offerings/reliant-real-estate-management/reliant-self-storage-fund-iii',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Self-Storage',
      securities_offered: 'Equity',
      short_description:
        'Reliant Self-Storage Fund III is a $75 MM equity fund offered from an experienced top 30 self-storage sponsor targeting acquisitions of a diversified portfolio of value-add and stabilized self-storage properties across the United States. -Matt Blackwell, Reliant Real Estate Management',
      sponsor: 'Reliant Real Estate Management',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.07',
      target_equity_multiple: '1.86x',
    },
    description:
      'Reliant Self-Storage Fund III is a $75 MM equity fund offered from an experienced top 30 self-storage sponsor targeting acquisitions of a diversified portfolio of value-add and stabilized self-storage properties across the United States. -Matt Blackwell, Reliant Real Estate Management',
    id: 46,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjbVZzYVdGdWRDMW9aV0ZrWlhJdGNtVmhiR055YjNka0xXNWxkeTAxTkRBdWFuQm46YzJiZGZkY2JkOWI1NDcxMWFlYmVhMmZiMjAxYzcxYWQtOTBlN2Y2NmJjY2RmNDQzM2FmNWZlZTJkNGJhNDRjZTQ1&1642542703',
    name: 'Reliant Self-Storage Fund III',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'reliant-self-storage-fund-iii',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Self-Storage',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:49:34.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/reliant-self-storage-fund-iii',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/renew-mills-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:16.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_1_Thumbnail_Email_2_Main-1647474832962-1647474848089.png',
      investment_strategy: 'Value-Add',
      name: 'ReNew Mills',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Ontario, CA',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Interwest Capital Group',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.047',
      target_equity_multiple: '1.9x',
    },
    description: '',
    id: 110,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_1_Thumbnail_Email_2_Main-1647474832962-1647474848089.png',
    name: 'ReNew Mills',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'renew-mills',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:54.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/renew-mills',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/sandman-santa-rosa-hotel-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '10000-49999',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '17%',
      },
    ],
    created_at: '2022-03-30T18:31:39.000000Z',
    data: {
      home_offer_type: 'Real Estate - Hospitality',
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_2_Thumbnail_Email_1_Main-1647044918934-1647044947001.png',
      investment_strategy: 'Value-Add',
      name: 'Sandman Santa Rosa Hotel',
      offer_investment_term: '5-9',
      offer_is_featured: null,
      offer_minimum_investment: '10000-49999',
      offer_offering_link: 'https://app.crowdstreet.com/properties/the-sandman-santa-rosa-hotel',
      offer_open_to_non_accredited: 'No',
      offer_platform: 'CrowdStreet',
      offer_projected_return: '17%',
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article:
        'https://www.benzinga.com/real-estate/22/03/26336003/private-equity-real-estate-investment-offering-for-boutique-hotel-in-sonoma-countys-wine-region',
      product_take: 'Incredible value-add opportunity with very limited downside risk',
      property_location: 'Santa Rosa, CA',
      property_type: 'Hospitality',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Yang Capital',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.094',
      target_equity_multiple: '2.1x',
    },
    description: '',
    id: 97,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_2_Thumbnail_Email_1_Main-1647044918934-1647044947001.png',
    name: 'Sandman Santa Rosa Hotel',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'sandman-santa-rosa-hotel',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Hospitality',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-30T18:31:39.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/sandman-santa-rosa-hotel',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'Spaxel Anthony Ave',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 28,
    image: null,
    name: 'Spaxel Anthony Ave',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'spaxel-anthony-ave',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/spaxel-anthony-ave',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/crowdstreet/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '0-100',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '',
      },
    ],
    created_at: '2022-02-01T04:20:43.000000Z',
    data: {
      home_offer_type: '',
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Screen_Shot_2022-01-21_at_9.39.39_AM-1642786855925-1642787094392.png',
      investment_strategy: 'Development',
      name: 'St. Pete Marriott Moxy OZ',
      offer_investment_term: 'na',
      offer_is_featured: null,
      offer_minimum_investment: '0-100',
      offer_offering_link: 'https://app.crowdstreet.com/properties/st-pete-moxy-hotel/',
      offer_open_to_non_accredited: '',
      offer_platform: 'CrowdStreet',
      offer_projected_return: '',
      offering_amount: '7,650,000',
      offering_close_date: '2/18/2022',
      offering_launch_date: '1/31/2022',
      product_article: '',
      product_take: '',
      property_location: 'St. Petersburg, FL',
      property_type: 'Hospitality',
      securities_offered: 'Equity',
      short_description:
        'An opportunity zone development of a 163-key Marriott Moxy Hotel located in EDGE District of Downtown St. Petersburg, FL, located directly across the street from the $2.7-3.8B redevelopment of the Tampa Bay Rays\u2019 Tropicana Field.',
      sponsor: 'DoveHill Capital Management',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.153',
      target_equity_multiple: '2.7x',
    },
    description:
      'An opportunity zone development of a 163-key Marriott Moxy Hotel located in EDGE District of Downtown St. Petersburg, FL, located directly across the street from the $2.7-3.8B redevelopment of the Tampa Bay Rays\u2019 Tropicana Field.',
    id: 42,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Screen_Shot_2022-01-21_at_9.39.39_AM-1642786855925-1642787094392.png',
    name: 'St. Pete Marriott Moxy OZ',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'st-pete-marriott-moxy-oz',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Hospitality',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:06.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/st-pete-marriott-moxy-oz',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'StartEngine Real Estate REIT',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 27,
    image: null,
    name: 'StartEngine Real Estate REIT',
    owner: {
      id: 138249,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/08/03112954/StartEngine.png',
      name: 'StartEngine',
      slug: 'startengine',
      url: 'https://www.benzinga.com/alternative-investments/platform/startengine',
    },
    slug: 'startengine-real-estate-reit',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/startengine-real-estate-reit',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/sterling-hotel-conversion-portfolio-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:20:58.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjMmh6TFhKbGJtUmxjaTAxTkRCNE16WTNMV055YjNBdWNHNW46N2ExYmY0MDQzMWZmNDMwMGJiN2YzMzM2NDcyNjE1MTItNjlkODE2OWY4NmZmNDQ1YWE3OTFjYzc2YjliMjdiZjY1&1641532716',
      investment_strategy: 'Opportunistic',
      name: 'Sterling Hotel Conversion Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link:
        'https://www.realcrowd.com/offerings/sterling-real-estate-partners/sterling-hotel-conversion-portfolio',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '2/15/2022',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Scottsdale and Tucson, AZ',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'Hotel to multifamily conversion portfolio located in high quality Arizona submarkets acquired at 25% discount to comparable properties.',
      sponsor: 'Sterling Real Estate Partners',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.0717',
      target_equity_multiple: '1.98x',
    },
    description:
      'Hotel to multifamily conversion portfolio located in high quality Arizona submarkets acquired at 25% discount to comparable properties.',
    id: 47,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RjMmh6TFhKbGJtUmxjaTAxTkRCNE16WTNMV055YjNBdWNHNW46N2ExYmY0MDQzMWZmNDMwMGJiN2YzMzM2NDcyNjE1MTItNjlkODE2OWY4NmZmNDQ1YWE3OTFjYzc2YjliMjdiZjY1&1641532716',
    name: 'Sterling Hotel Conversion Portfolio',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'sterling-hotel-conversion-portfolio',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:16.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/sterling-hotel-conversion-portfolio',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '$5,080',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '8%-9%',
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: 'Real Estate - Office',
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/15001904/1st-streit-office-reit-768x512.jpg',
      investment_strategy: null,
      name: '1st Streit Office',
      offer_investment_term: '5 Years',
      offer_is_featured: null,
      offer_minimum_investment: '$5,080',
      offer_offering_link: 'https://benzinga.com/go/streitwise',
      offer_open_to_non_accredited: 'Yes',
      offer_platform: 'Streitwise',
      offer_projected_return: '8%-9%',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 18,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/15001904/1st-streit-office-reit-768x512.jpg',
    name: '1st Streit Office',
    owner: {
      id: 57641,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/01/28180747/streitwise-logo-text-1-768x143.png',
      name: 'Streitwise',
      slug: 'streitwise',
      url: 'https://www.benzinga.com/alternative-investments/platform/streitwise',
    },
    slug: 'streitwise',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Non-Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2021-12-02T18:38:34.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/streitwise',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/farmtogether/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-23T18:15:51.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://cdn.benzinga.com/files/imagecache/1024x768xUP/images/story/2012/farm-g03f7e5e1d_1280.jpg',
      investment_strategy: 'Growth, Income',
      name: 'Sustainable Farmland Fund',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'FarmTogether',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'U.S.',
      property_type: 'Farmland',
      securities_offered: 'Equity',
      short_description:
        'The fund will invest in a range of farmland opportunities across both permanent and row crops in prime growing regions of the U.S., including tree nuts, citrus, and apples, in which FarmTogether has extensive expertise.',
      sponsor: 'FarmTogether Management',
      target_cash_yield_high: '0.06',
      target_cash_yield_low: '0.04',
      target_equity_multiple: '',
    },
    description:
      'The fund will invest in a range of farmland opportunities across both permanent and row crops in prime growing regions of the U.S., including tree nuts, citrus, and apples, in which FarmTogether has extensive expertise.',
    id: 95,
    image: 'https://cdn.benzinga.com/files/imagecache/1024x768xUP/images/story/2012/farm-g03f7e5e1d_1280.jpg',
    name: 'Sustainable Farmland Fund',
    owner: {
      id: 67335,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/04/29101331/Screen-Shot-2020-04-29-at-10.02.28-AM.png',
      name: 'FarmTogether',
      slug: 'farmtogether',
      url: 'https://www.benzinga.com/alternative-investments/platform/farmtogether',
    },
    slug: 'sustainable-farmland-fund',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Farmland',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-23T18:15:51.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/sustainable-farmland-fund',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/the-annex-of-pullman-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-05T13:56:58.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Emma_-_labels_29_-1648565523960-1648565655564.png',
      investment_strategy: 'Development',
      name: 'The Annex of Pullman',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/washington-state-university',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Pullman, WA',
      property_type: 'Multifamily, Student Housing',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'The Annex Group',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.046',
      target_equity_multiple: '1.8x',
    },
    description: '',
    id: 105,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Emma_-_labels_29_-1648565523960-1648565655564.png',
    name: 'The Annex of Pullman',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'the-annex-of-pullman',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily, Student Housing',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-05T13:56:58.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-annex-of-pullman',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T16:41:02.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/129/4be3928b4689a8b1f2469cfaf96e772d.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Avebury',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '126,330',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Huntsville, AR',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Avebury is a beautiful and nearly new open concept home with three bedrooms and three bathrooms. The property features an isolated master bedroom with a trey ceiling and walk in closets. There is a great backyard with a full privacy fence.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.056',
      target_equity_multiple: '',
    },
    description:
      'The Avebury is a beautiful and nearly new open concept home with three bedrooms and three bathrooms. The property features an isolated master bedroom with a trey ceiling and walk in closets. There is a great backyard with a full privacy fence.',
    id: 92,
    image:
      'https://images.arrivedhomes.com/properties/129/4be3928b4689a8b1f2469cfaf96e772d.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Avebury',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-avebury',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:15.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-avebury',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-05T13:56:43.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://images.arrivedhomes.com/properties/133/06a5750b322e8d6348910c0bc0cb684e.jpg',
      investment_strategy: 'Growth, Income',
      name: 'The Bedford',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Columbia, SC',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '0.07',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description: '',
    id: 99,
    image: 'https://images.arrivedhomes.com/properties/133/06a5750b322e8d6348910c0bc0cb684e.jpg',
    name: 'The Bedford',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-bedford',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:31.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-bedford',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T16:40:52.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/125/38bb26a5e93179b342c17ec2157a2522.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Chelsea',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '137,970',
      offering_close_date: '',
      offering_launch_date: '',
      product_article:
        'https://www.benzinga.com/real-estate/22/03/26169582/arrived-homes-expands-into-new-market-with-latest-offering-for-fractionalized-rental-property-invest',
      product_take:
        'South Carolina is a growing market with projections showing continued growth for several years to come',
      property_location: 'Birmingham, AL',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'Chelsea is a cozy three bedroom and two and a half bathroom home featuring a two car garage. The property is conveniently located in Chelsea Park with great natural amenities such as multiple lakes, a park and walking trails.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.048',
      target_equity_multiple: '',
    },
    description:
      'Chelsea is a cozy three bedroom and two and a half bathroom home featuring a two car garage. The property is conveniently located in Chelsea Park with great natural amenities such as multiple lakes, a park and walking trails.',
    id: 88,
    image:
      'https://images.arrivedhomes.com/properties/125/38bb26a5e93179b342c17ec2157a2522.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Chelsea',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-chelsea',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-05T13:56:18.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-chelsea',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T18:00:03.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/117/03ebe9c59e50fc7ed2f18dc41f840131.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Delta',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '145,480',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Atlanta, GA',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Delta is a stunning one owner "Smart Home" built in 2019. Features include a gourmet pendant lit kitchen island, granite countertops, caf\u00e9 area and stainless steel appliances. The spacious master suite features walk in closets, trey ceilings, spa-like master bath that features double vanities, separate shower, and a garden bathtub. The family room overlooks the kitchen and has a designer electric fireplace. The backyard privacy fence and patio are perfect for exclusive entertaining. The Delta is located in Atlanta, GA.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.032',
      target_equity_multiple: '',
    },
    description:
      'The Delta is a stunning one owner "Smart Home" built in 2019. Features include a gourmet pendant lit kitchen island, granite countertops, caf\u00e9 area and stainless steel appliances. The spacious master suite features walk in closets, trey ceilings, spa-like master bath that features double vanities, separate shower, and a garden bathtub. The family room overlooks the kitchen and has a designer electric fireplace. The backyard privacy fence and patio are perfect for exclusive entertaining. The Delta is located in Atlanta, GA.',
    id: 79,
    image:
      'https://images.arrivedhomes.com/properties/117/03ebe9c59e50fc7ed2f18dc41f840131.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Delta',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-delta',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:45.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-delta',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/the-district-at-celina-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:11.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_1_Email_1_Side_Email_2_Main-1648576036535-1648576056168.png',
      investment_strategy: 'Development',
      name: 'The District at Celina',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Celina, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Cypress Equity Investments',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.012',
      target_equity_multiple: '1.8x',
    },
    description: '',
    id: 108,
    image:
      'https://prod-thumbnails.investorportal.pictures/property-images/Carousel_1_Email_1_Side_Email_2_Main-1648576036535-1648576056168.png',
    name: 'The District at Celina',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'the-district-at-celina',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:49.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-district-at-celina',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:40.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/112/f31157517d90b2b422b7f47d509eca47.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Dolittle',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Columbia, SC',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Murphy is a brand new home that includes 3 bedrooms and 2 bathrooms. It has a gas fireplace, and the kitchen has a gas range with stainless steel appliances. The master suite includes a soaking tub and a walk-in closet, and the other 2 bedrooms share a Jack-and-Jill bathroom. Home is located in Chapin, SC.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.06',
      target_equity_multiple: '',
    },
    description:
      'The Murphy is a brand new home that includes 3 bedrooms and 2 bathrooms. It has a gas fireplace, and the kitchen has a gas range with stainless steel appliances. The master suite includes a soaking tub and a walk-in closet, and the other 2 bedrooms share a Jack-and-Jill bathroom. Home is located in Chapin, SC.',
    id: 59,
    image:
      'https://images.arrivedhomes.com/properties/112/f31157517d90b2b422b7f47d509eca47.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Dolittle',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-dolittle',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:56.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-dolittle',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '$100',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '10.7%',
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: 'Real Estate - Rental',
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/20173628/439b8f837adaead973a32464c147442f-768x462.jpg',
      investment_strategy: null,
      name: 'The Elevation - Rental Property',
      offer_investment_term: '5-7 years',
      offer_is_featured: null,
      offer_minimum_investment: '$100',
      offer_offering_link: 'https://www.benzinga.com/go/arrived-homes-offering-card',
      offer_open_to_non_accredited: 'Yes',
      offer_platform: 'Arrived Homes',
      offer_projected_return: '10.7%',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: '',
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: '',
    id: 41,
    image:
      'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/20173628/439b8f837adaead973a32464c147442f-768x462.jpg',
    name: 'The Elevation - Rental Property',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-elevation-rental-property',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Non-Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-elevation-rental-property',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-05T13:56:55.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://images.arrivedhomes.com/properties/135/2285ff31823adc05e4d9c5f8530647e6.jpg',
      investment_strategy: 'Growth, Income',
      name: 'The Gardens',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Tuscaloosa, AL',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '0.07',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description: '',
    id: 104,
    image: 'https://images.arrivedhomes.com/properties/135/2285ff31823adc05e4d9c5f8530647e6.jpg',
    name: 'The Gardens',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-gardens',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:42.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-gardens',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/crowdstreet/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:25.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/L1050091-1642785613070-1642785979905.png',
      investment_strategy: 'Value-Add',
      name: 'The Georgian Santa Monica',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/georgian-hotel/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '20,389,671',
      offering_close_date: '2/15/2022',
      offering_launch_date: '02/09/2022',
      product_article: '',
      product_take: '',
      property_location: 'Santa Monica, CA',
      property_type: 'Hospitality',
      securities_offered: 'Equity',
      short_description:
        'Known since 1933 as Santa Monica\u2019s First Lady, The Georgian is one of L.A\u2019.s most iconic hotels. Located along the coveted Ocean Ave, The Georgian is steps from the Santa Monica Beach, Third Street Promenade, and downtown Santa Monica.',
      sponsor: 'BLVD Hospitality',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.085',
      target_equity_multiple: '2.3x',
    },
    description:
      'Known since 1933 as Santa Monica\u2019s First Lady, The Georgian is one of L.A\u2019.s most iconic hotels. Located along the coveted Ocean Ave, The Georgian is steps from the Santa Monica Beach, Third Street Promenade, and downtown Santa Monica.',
    id: 65,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/L1050091-1642785613070-1642785979905.png',
    name: 'The Georgian Santa Monica',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'the-georgian-santa-monica',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Hospitality',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:36:01.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-georgian-santa-monica',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:58.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/124/2cc11a39ea7e156ab6ac59890e7e7111.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Greenhill',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '140,510',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Elgin, SC',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Greenhill is a charming, newly constructed brick build in the Elgin, SC. The spacious 4 bedroom 2 bathroom home boasts a great layout, including a sunroom and den space on the first floor. The den space has flex use for a home office, perfect for telecommuting. Primary bedroom hosts a walk-in closet, sitting area, and an impressive en suite bathroom. The primary bedroom\u2019s en suite bath features a garden tub, separate shower, and double vanity with quartz countertops.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.044',
      target_equity_multiple: '',
    },
    description:
      'The Greenhill is a charming, newly constructed brick build in the Elgin, SC. The spacious 4 bedroom 2 bathroom home boasts a great layout, including a sunroom and den space on the first floor. The den space has flex use for a home office, perfect for telecommuting. Primary bedroom hosts a walk-in closet, sitting area, and an impressive en suite bathroom. The primary bedroom\u2019s en suite bath features a garden tub, separate shower, and double vanity with quartz countertops.',
    id: 77,
    image:
      'https://images.arrivedhomes.com/properties/124/2cc11a39ea7e156ab6ac59890e7e7111.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Greenhill',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-greenhill',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:40.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-greenhill',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T16:40:55.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/126/f3e4fcae456602ee638d1bf419dda4fa.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Hadden',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '110,930',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Greenville, SC',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'This lovely home features three bedrooms, two full baths and one car attached garage. The entrance of the home opens into a spacious living and kitchen area. The laminate flooring offers a modern feel. The master bedroom includes a full bath.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.056',
      target_equity_multiple: '',
    },
    description:
      'This lovely home features three bedrooms, two full baths and one car attached garage. The entrance of the home opens into a spacious living and kitchen area. The laminate flooring offers a modern feel. The master bedroom includes a full bath.',
    id: 89,
    image:
      'https://images.arrivedhomes.com/properties/126/f3e4fcae456602ee638d1bf419dda4fa.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Hadden',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-hadden',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:08.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-hadden',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T16:40:57.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/127/e414db638ced068c8cc9f1d0c180b3ba.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Hollandaise',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '164,610',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Nashville, TN',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'Elegant vaulted ceilings & Loft overlooking family room, staggered cabinets in eat in kitchen, private master suite down, other bedrooms up. Less than 2 minutes to Hurricane Creek Recreation Area and Boat Ramp!',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.036',
      target_equity_multiple: '',
    },
    description:
      'Elegant vaulted ceilings & Loft overlooking family room, staggered cabinets in eat in kitchen, private master suite down, other bedrooms up. Less than 2 minutes to Hurricane Creek Recreation Area and Boat Ramp!',
    id: 90,
    image:
      'https://images.arrivedhomes.com/properties/127/e414db638ced068c8cc9f1d0c180b3ba.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Hollandaise',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-hollandaise',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:10.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-hollandaise',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/the-huntley-apartments-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:32.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/img429.jpg?',
      investment_strategy: 'Growth, Income',
      name: 'The Huntley Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealtyMogul',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Beaverton, OR',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Next Wave Investors',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.056',
      target_equity_multiple: '1.5x',
    },
    description: '',
    id: 116,
    image: 'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/img429.jpg?',
    name: 'The Huntley Apartments',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'the-huntley-apartments',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:28:08.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-huntley-apartments',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-05T13:56:46.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://images.arrivedhomes.com/properties/132/f8437cefa742b2cdf88832fdb1dac756.jpg',
      investment_strategy: 'Growth, Income',
      name: 'The Jack',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Nashville, TN',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '0.07',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description: '',
    id: 100,
    image: 'https://images.arrivedhomes.com/properties/132/f8437cefa742b2cdf88832fdb1dac756.jpg',
    name: 'The Jack',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-jack',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:33.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-jack',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/crowdstreet/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:20.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Screen_Shot_2022-02-01_at_4.20.39_PM-1643761285661-1643761345118.png',
      investment_strategy: 'Development',
      name: 'The Joinery Phase II',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/the-joinery-ii/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '28,000,000',
      offering_close_date: '3/1/2022',
      offering_launch_date: '2/7/2022',
      product_article: '',
      product_take: '',
      property_location: 'Charlotte, NC',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description:
        'A two-building multifamily community and second phase of a walkable, master planned development. The site is in a strong Charlotte, NC submarket - recent 17% rent growth and low vacancy - and is just minutes to Downtown and employment nodes.',
      sponsor: 'Swinerton, Space Craft',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.007',
      target_equity_multiple: '1.7x',
    },
    description:
      'A two-building multifamily community and second phase of a walkable, master planned development. The site is in a strong Charlotte, NC submarket - recent 17% rent growth and low vacancy - and is just minutes to Downtown and employment nodes.',
    id: 63,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/Screen_Shot_2022-02-01_at_4.20.39_PM-1643761285661-1643761345118.png',
    name: 'The Joinery Phase II',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'the-joinery-phase-ii',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:05.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-joinery-phase-ii',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'The Julian Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 9,
    image: null,
    name: 'The Julian Apartments',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'the-julian-apartments',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-julian-apartments',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T18:00:05.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/118/b1085f781a2ddb59750a970f3c35ff0e.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Kawana',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '127,030',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Harvest, AL',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Kawana is an incredibly spacious 3 bedroom 2.5 bathroom home that was built in 2012. The property has a large backyard with a privacy fence and a two-car garage. The upstairs area provides an extra room for working from home and plenty of storage throughout. The kitchen features granite countertops, island and lots of cabinets. The Kawana is located in Harvest, AL.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.04',
      target_equity_multiple: '',
    },
    description:
      'The Kawana is an incredibly spacious 3 bedroom 2.5 bathroom home that was built in 2012. The property has a large backyard with a privacy fence and a two-car garage. The upstairs area provides an extra room for working from home and plenty of storage throughout. The kitchen features granite countertops, island and lots of cabinets. The Kawana is located in Harvest, AL.',
    id: 80,
    image:
      'https://images.arrivedhomes.com/properties/118/b1085f781a2ddb59750a970f3c35ff0e.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Kawana',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-kawana',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:47.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-kawana',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:30.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/105/27976781631eb4c08456b2c0355a16a5.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The KerriAnn',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '146,350',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Clayton, NC',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The KerriAnn is a large & open 2-story home in the heart of Clayton. Tons of natural light, a fully-fenced backyard with patio, 3 bedrooms, 2.5 bathrooms, and a bonus room that could be utilized as a formal living room, dining room, or study. Spacious master bedroom with large walk-in closet, hardwood floors, kitchen with backsplash and pantry and a loft!',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.054',
      target_equity_multiple: '',
    },
    description:
      'The KerriAnn is a large & open 2-story home in the heart of Clayton. Tons of natural light, a fully-fenced backyard with patio, 3 bedrooms, 2.5 bathrooms, and a bonus room that could be utilized as a formal living room, dining room, or study. Spacious master bedroom with large walk-in closet, hardwood floors, kitchen with backsplash and pantry and a loft!',
    id: 66,
    image:
      'https://images.arrivedhomes.com/properties/105/27976781631eb4c08456b2c0355a16a5.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The KerriAnn',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-kerriann',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-02-23T19:36:06.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-kerriann',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/the-langston-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T00:30:28.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/04-1645825172394-1645825509715.png',
      investment_strategy: 'Development',
      name: 'The Langston',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://app.crowdstreet.com/properties/the-langston/',
      offer_open_to_non_accredited: null,
      offer_platform: 'CrowdStreet',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Washington D.C.',
      property_type: 'Mixed-Use',
      securities_offered: 'Equity',
      short_description:
        'A to-be-built, mixed-use development w/ 204 luxury apartments, 15,443 SF of retail, and 77 underground parking spaces. The Project will be located in Shaw, one of Washington, D.C.\u2019s popular residential areas and next to the Shaw-Howard Univ Metro Station.',
      sponsor: 'Capstone Development',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.025',
      target_equity_multiple: '2.2x',
    },
    description:
      'A to-be-built, mixed-use development w/ 204 luxury apartments, 15,443 SF of retail, and 77 underground parking spaces. The Project will be located in Shaw, one of Washington, D.C.\u2019s popular residential areas and next to the Shaw-Howard Univ Metro Station.',
    id: 87,
    image:
      'https://prod-thumbnails.investorportal.pictures/custom/1170/400/property-images/04-1645825172394-1645825509715.png',
    name: 'The Langston',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'the-langston',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Mixed-Use',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-03-23T18:15:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-langston',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'The Link Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 8,
    image: null,
    name: 'The Link Apartments',
    owner: {
      id: 44119,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/07/29131345/CS-Marketplace-Logo.png',
      name: 'CrowdStreet',
      slug: 'crowdstreet',
      url: 'https://www.benzinga.com/alternative-investments/platform/crowdstreet',
    },
    slug: 'the-link-apartments',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-link-apartments',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-05T13:56:53.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://images.arrivedhomes.com/properties/134/09be5b75cdf5c6f046079f7d0c83af44.jpg',
      investment_strategy: 'Growth, Income',
      name: 'The Louise',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Tuscaloosa, AL',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '0.07',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description: '',
    id: 103,
    image: 'https://images.arrivedhomes.com/properties/134/09be5b75cdf5c6f046079f7d0c83af44.jpg',
    name: 'The Louise',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-louise',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:40.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-louise',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T18:00:08.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/120/790902b57b3d16e656b00ccf425fcfaa.jpeg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Lovejoy',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '128,360',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Hampton, GA',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Lovejoy was newly constructed in 2020 in the community of Hampton, GA. The two-story home features 3 bedrooms and 3 bathrooms with granite countertops and a two-car garage.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.032',
      target_equity_multiple: '',
    },
    description:
      'The Lovejoy was newly constructed in 2020 in the community of Hampton, GA. The two-story home features 3 bedrooms and 3 bathrooms with granite countertops and a two-car garage.',
    id: 81,
    image:
      'https://images.arrivedhomes.com/properties/120/790902b57b3d16e656b00ccf425fcfaa.jpeg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Lovejoy',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-lovejoy',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:49.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-lovejoy',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'The Meadows at Canton',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 13,
    image: null,
    name: 'The Meadows at Canton',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'the-meadows-at-canton',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-meadows-at-canton',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2021-12-02T18:38:34.000000Z',
    data: {
      home_offer_type: null,
      image: null,
      investment_strategy: null,
      name: 'The Meadows at Farmington Hills',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: null,
      offer_open_to_non_accredited: null,
      offer_platform: null,
      offer_projected_return: null,
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: null,
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: null,
    id: 14,
    image: null,
    name: 'The Meadows at Farmington Hills',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'the-meadows-at-farmington-hills',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-meadows-at-farmington-hills',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/the-miami-industrial-portfolio-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T17:59:55.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RhVzFoWjJVd01ERXROVFF3ZURNMk55MWpjbTl3TG5CdVp3PT06YTU4Zjk0NmFmODYyNDVlYmIzOTdiMTlkYzhiMGFiZGMtMDJlMTJkZGM0YzIxNGUwNTg1MDIxN2QyNDA2NWFjNzk1&1644191121',
      investment_strategy: 'Value Add',
      name: 'The Miami Industrial Portfolio',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://www.realcrowd.com/offerings/the-o-donnell-group/the-miami-industrial-portfolio',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealCrowd',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Miami, FL',
      property_type: 'Industrial',
      securities_offered: 'Equity',
      short_description:
        "The O'Donnell Group is strategically acquiring five (5) last-mile value-add industrial assets totaling over 250,000 square feet at a significant discount to replacement cost. With tenants on short-term leases, and in place rents 30% below market, The O\u2019Donnell Group sees tremendous upside potential through investing in capital expenditure and realizing market rate rents.",
      sponsor: "The O'Donnell Group",
      target_cash_yield_high: '',
      target_cash_yield_low: '',
      target_equity_multiple: '1.52x',
    },
    description:
      "The O'Donnell Group is strategically acquiring five (5) last-mile value-add industrial assets totaling over 250,000 square feet at a significant discount to replacement cost. With tenants on short-term leases, and in place rents 30% below market, The O\u2019Donnell Group sees tremendous upside potential through investing in capital expenditure and realizing market rate rents.",
    id: 76,
    image:
      'https://www.realcrowd.com/file?id=YVcxaFoyVnpMWEJ5YVcxaGNua3RhVzFoWjJVd01ERXROVFF3ZURNMk55MWpjbTl3TG5CdVp3PT06YTU4Zjk0NmFmODYyNDVlYmIzOTdiMTlkYzhiMGFiZGMtMDJlMTJkZGM0YzIxNGUwNTg1MDIxN2QyNDA2NWFjNzk1&1644191121',
    name: 'The Miami Industrial Portfolio',
    owner: {
      id: 148986,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/16110132/RealCrowd.Color_-768x86.png',
      name: 'RealCrowd',
      slug: 'realcrowd',
      url: 'https://www.benzinga.com/alternative-investments/platform/realcrowd',
    },
    slug: 'the-miami-industrial-portfolio',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Industrial',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:38.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-miami-industrial-portfolio',
  },
  {
    affiliate_link: null,
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: '$100',
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: '12%',
      },
    ],
    created_at: '2022-01-05T17:37:32.000000Z',
    data: {
      home_offer_type: 'Real Estate- Rental',
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/20173728/The-Odessa-Arrived-Homes-768x462.jpg',
      investment_strategy: null,
      name: 'The Odessa - Rental Property',
      offer_investment_term: '5-7 years',
      offer_is_featured: null,
      offer_minimum_investment: '$100',
      offer_offering_link: 'https://www.benzinga.com/go/arrived-homes-offering-card',
      offer_open_to_non_accredited: 'Yes',
      offer_platform: 'Arrived Homes',
      offer_projected_return: '12%',
      offering_amount: null,
      offering_close_date: null,
      offering_launch_date: null,
      product_article: null,
      product_take: null,
      property_location: null,
      property_type: null,
      securities_offered: null,
      short_description: '',
      sponsor: null,
      target_cash_yield_high: null,
      target_cash_yield_low: null,
      target_equity_multiple: null,
    },
    description: '',
    id: 40,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/12/20173728/The-Odessa-Arrived-Homes-768x462.jpg',
    name: 'The Odessa - Rental Property',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-odessa-rental-property',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: null,
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Non-Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-01-05T17:37:32.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-odessa-rental-property',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T16:41:04.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/130/35da116092e137a55e54b4c2aa821e30.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Otoro',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '171,860',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Atlanta, GA',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'This welcoming two-story Atlanta home offers granite countertops and a two car garage. The house has plenty of room with four bedrooms and two and a half bathrooms. The community even features a shared clubhouse, pool and tennis courts.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.049',
      target_equity_multiple: '',
    },
    description:
      'This welcoming two-story Atlanta home offers granite countertops and a two car garage. The house has plenty of room with four bedrooms and two and a half bathrooms. The community even features a shared clubhouse, pool and tennis courts.',
    id: 93,
    image:
      'https://images.arrivedhomes.com/properties/130/35da116092e137a55e54b4c2aa821e30.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Otoro',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-otoro',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:17.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-otoro',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-05T13:56:51.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://images.arrivedhomes.com/properties/136/9a2fe6e44159a166eb422223cb4eb3d6.jpg',
      investment_strategy: 'Growth, Income',
      name: 'The Peanut',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Tuscaloosa, AL',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '0.07',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description: '',
    id: 102,
    image: 'https://images.arrivedhomes.com/properties/136/9a2fe6e44159a166eb422223cb4eb3d6.jpg',
    name: 'The Peanut',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-peanut',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:38.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-peanut',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-01T04:21:42.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/115/bee4f4bac46cacf34c73f8e2d00190ae.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Ribbonwalk',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: 'TBD',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Charlotte, NC',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        "The Ribbonwalk is a beautiful 4 bedroom home located in Charlotte, NC. It features granite kitchen countertops with subway tile backsplash, 30\u2019 kitchen cabinets, upgraded LVT flooring on the first floor, raised height vanities, and a master bath with a 5 ft. shower. The large garage and back yard provide plenty of space and it's also close proximity to dining and shopping.",
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.06',
      target_equity_multiple: '',
    },
    description:
      "The Ribbonwalk is a beautiful 4 bedroom home located in Charlotte, NC. It features granite kitchen countertops with subway tile backsplash, 30\u2019 kitchen cabinets, upgraded LVT flooring on the first floor, raised height vanities, and a master bath with a 5 ft. shower. The large garage and back yard provide plenty of space and it's also close proximity to dining and shopping.",
    id: 60,
    image:
      'https://images.arrivedhomes.com/properties/115/bee4f4bac46cacf34c73f8e2d00190ae.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Ribbonwalk',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-ribbonwalk',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:25:58.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-ribbonwalk',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-16T16:41:00.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/128/04863bc1a87b748e39879a53e60d8aeb.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Terracotta',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '139,820',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Tucson, AZ',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Terracotta is a beautiful three bedroom and three bathroom home with an attached two car garage. The home includes ceiling fans throughout, tile flooring on the entire first level as well as wet areas, surround sound pre-wire, whole house water softener.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.041',
      target_equity_multiple: '',
    },
    description:
      'The Terracotta is a beautiful three bedroom and three bathroom home with an attached two car garage. The home includes ceiling fans throughout, tile flooring on the entire first level as well as wet areas, surround sound pre-wire, whole house water softener.',
    id: 91,
    image:
      'https://images.arrivedhomes.com/properties/128/04863bc1a87b748e39879a53e60d8aeb.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Terracotta',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-terracotta',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:13.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-terracotta',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-05T13:56:48.000000Z',
    data: {
      home_offer_type: null,
      image: 'https://images.arrivedhomes.com/properties/131/2ce1cc0288f7b2ea22bc5cdb7bc0f400.jpg',
      investment_strategy: 'Growth, Income',
      name: 'The Tulip',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Tuscaloosa, AL',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '0.07',
      target_cash_yield_low: '0.05',
      target_equity_multiple: '',
    },
    description: '',
    id: 101,
    image: 'https://images.arrivedhomes.com/properties/131/2ce1cc0288f7b2ea22bc5cdb7bc0f400.jpg',
    name: 'The Tulip',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-tulip',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:27:36.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-tulip',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/arrived-homes/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-02-23T18:00:00.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://images.arrivedhomes.com/properties/122/d336af9f6e3aea84494d5c05ec748523.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
      investment_strategy: 'Growth, Income',
      name: 'The Wave',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'Arrived Homes',
      offer_projected_return: null,
      offering_amount: '143,330',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Fairburn, GA',
      property_type: 'Residential',
      securities_offered: 'Equity',
      short_description:
        'The Wave is a charming two-story home in Fairburn, GA. The 3 bedroom and 3 bathroom home offers granite countertops and a two-car garage. The community features several shared amenities including a clubhouse, park, pool and tennis courts. The Wave was built in 2017.',
      sponsor: 'Arrived Homes',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.032',
      target_equity_multiple: '',
    },
    description:
      'The Wave is a charming two-story home in Fairburn, GA. The 3 bedroom and 3 bathroom home offers granite countertops and a two-car garage. The community features several shared amenities including a clubhouse, park, pool and tennis courts. The Wave was built in 2017.',
    id: 78,
    image:
      'https://images.arrivedhomes.com/properties/122/d336af9f6e3aea84494d5c05ec748523.jpg?tr=dpr-auto,pr-true,di-logo_icon_CwvvbRzw9.svg,ar-373-224,w-1440',
    name: 'The Wave',
    owner: {
      id: 136344,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/07/26170353/arrived-logo-768x210.png',
      name: 'Arrived Homes',
      slug: 'arrived-homes',
      url: 'https://www.benzinga.com/alternative-investments/platform/arrived-homes',
    },
    slug: 'the-wave',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Residential',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:43.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/the-wave',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/tides-on-oakland-hills-apartments-offering/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-04-08T00:25:29.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/6011-oakland-hills-dr-fort-worth-tx-76112-high-res-26.jpg',
      investment_strategy: 'Growth, Income',
      name: 'Tides on Oakland Hills Apartments',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: '',
      offer_open_to_non_accredited: null,
      offer_platform: 'RealtyMogul',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '',
      product_article: '',
      product_take: '',
      property_location: 'Fort Worth, TX',
      property_type: 'Multifamily',
      securities_offered: 'Equity',
      short_description: '',
      sponsor: 'Tides Equities',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.023',
      target_equity_multiple: '1.61x',
    },
    description: '',
    id: 115,
    image:
      'https://www.realtymogul.com/sites/default/files/styles/private_placement_gallery_src/public/6011-oakland-hills-dr-fort-worth-tx-76112-high-res-26.jpg',
    name: 'Tides on Oakland Hills Apartments',
    owner: {
      id: 109535,
      image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/04/27120840/realty-mogul.png',
      name: 'RealtyMogul',
      slug: 'realty-mogul',
      url: 'https://www.benzinga.com/alternative-investments/platform/realty-mogul',
    },
    slug: 'tides-on-oakland-hills-apartments',
    status: 'available',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Multifamily',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:28:06.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/tides-on-oakland-hills-apartments',
  },
  {
    affiliate_link: 'https://www.benzinga.com/go/farmtogether/',
    attributes: [
      {
        label: 'Min. Investment',
        locked: false,
        type: 'minInvestment',
        value: null,
      },
      {
        label: 'Target Return',
        locked: false,
        type: 'targetReturn',
        value: null,
      },
    ],
    created_at: '2022-03-11T05:30:50.000000Z',
    data: {
      home_offer_type: null,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/03/10160208/johny-goerend-pnigODapPek-unsplash-1.jpg',
      investment_strategy: 'Growth, Income',
      name: 'Vista Luna Organic Vineyard',
      offer_investment_term: null,
      offer_is_featured: null,
      offer_minimum_investment: null,
      offer_offering_link: 'https://farmtogether.com/offerings/vista-luna#documents',
      offer_open_to_non_accredited: null,
      offer_platform: 'FarmTogether',
      offer_projected_return: null,
      offering_amount: '',
      offering_close_date: '',
      offering_launch_date: '3/11/2022',
      product_article:
        'https://www.benzinga.com/real-estate/22/03/26101370/new-farmland-investment-offering-for-a-high-cash-flowing-organic-vineyard',
      product_take:
        'This offering combines two of my favorite asset classes right now; farmland and wine. I believe that the demand for farmland is going to grow exponentially over the next several years. Adding the additional growth in the demand for wine will only compound the increase in value on this asset. ',
      property_location: 'CA',
      property_type: 'Farmland',
      securities_offered: 'Equity',
      short_description:
        'Vista Luna Organic Vineyard, FarmTogether\u2019s first wine grape deal, represents a compelling opportunity to invest in a high-cash-flowing, turn-key vineyard in an exciting California appellation with significant upside potential.',
      sponsor: 'FarmTogether Management',
      target_cash_yield_high: '',
      target_cash_yield_low: '0.081',
      target_equity_multiple: '1.9x',
    },
    description:
      'Vista Luna Organic Vineyard, FarmTogether\u2019s first wine grape deal, represents a compelling opportunity to invest in a high-cash-flowing, turn-key vineyard in an exciting California appellation with significant upside potential.',
    id: 85,
    image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/03/10160208/johny-goerend-pnigODapPek-unsplash-1.jpg',
    name: 'Vista Luna Organic Vineyard',
    owner: {
      id: 67335,
      image:
        'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/04/29101331/Screen-Shot-2020-04-29-at-10.02.28-AM.png',
      name: 'FarmTogether',
      slug: 'farmtogether',
      url: 'https://www.benzinga.com/alternative-investments/platform/farmtogether',
    },
    slug: 'vista-luna-organic-vineyard',
    status: 'funded',
    subtitle: null,
    tags: [
      {
        type: 'propertyType',
        value: 'Farmland',
        variant: 'default',
      },
      {
        type: 'investorType',
        value: 'Accredited',
        variant: 'default',
      },
    ],
    type: 'Real Estate',
    updated_at: '2022-04-11T16:26:59.000000Z',
    url: 'https://www.benzinga.com/alternative-investments/listing/vista-luna-organic-vineyard',
  },
];

export const MockWordpressPost: WordpressPost = {
  blocks: [
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The NBA has recently teamed up with Dapper Labs to create a digital version of NBA trading cards. However, these digital collectibles aren’t cards at all. </p>\n',
      ],
      innerHTML:
        '\n<p>The NBA has recently teamed up with Dapper Labs to create a digital version of NBA trading cards. However, these digital collectibles aren’t cards at all. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Instead they’re collectible in-game highlights from NBA players called Top Shots. NBA Top Shot releases packs of Top Shots on its website every so often, and they sell out quickly. The technology that makes these digital collectibles possible are <a href="https://www.benzinga.com/markets/cryptocurrency/21/02/19780218/nba-top-shot-cryptopunks-and-more-what-you-need-to-know-about-nfts">non-fungible tokens</a>.</p>\n',
      ],
      innerHTML:
        '\n<p>Instead they’re collectible in-game highlights from NBA players called Top Shots. NBA Top Shot releases packs of Top Shots on its website every so often, and they sell out quickly. The technology that makes these digital collectibles possible are <a href="https://www.benzinga.com/markets/cryptocurrency/21/02/19780218/nba-top-shot-cryptopunks-and-more-what-you-need-to-know-about-nfts">non-fungible tokens</a>.</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Unlike most NFTs, Top Shots aren’t ERC-721 tokens, instead these collectibles are NFTs on the Flow Blockchain, a blockchain created by Dapper Labs for NFTs. After Dapper labs clogged the Ethereum network in 2017 with Cryptokitties, they opted to create their own blockchain network for Top Shot. </p>\n',
      ],
      innerHTML:
        '\n<p>Unlike most NFTs, Top Shots aren’t ERC-721 tokens, instead these collectibles are NFTs on the Flow Blockchain, a blockchain created by Dapper Labs for NFTs. After Dapper labs clogged the Ethereum network in 2017 with Cryptokitties, they opted to create their own blockchain network for Top Shot. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Typically, non-fungible tokens use Ethereum’s blockchain to make it impossible to duplicate the collectible. Ethereum tokens used for digital art, concert tickets and collectibles all use the ERC-721 token standard for Ethereum tokens. What makes ERC-721 tokens special is that they’re non-fungible, meaning that each token is capable of holding a distinct value. </p>\n',
      ],
      innerHTML:
        '\n<p>Typically, non-fungible tokens use Ethereum’s blockchain to make it impossible to duplicate the collectible. Ethereum tokens used for digital art, concert tickets and collectibles all use the ERC-721 token standard for Ethereum tokens. What makes ERC-721 tokens special is that they’re non-fungible, meaning that each token is capable of holding a distinct value. </p>\n',
    },
    {
      attrs: {
        data: {
          _cta_placeholder_type: 'cta_placeholder_type',
          _default_cta: 'default_cta',
          cta_placeholder_type: 'primary',
          default_cta: '',
        },
        id: 'block_6053b3cdf7394',
        mode: 'edit',
        name: 'acf/cta-placeholder',
      },
      blockName: 'acf/cta-placeholder',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: {
        ordered: false,
      },
      blockName: 'advanced-gutenberg-blocks/summary',
      headers: [
        {
          html: 'NBA Top Shots NFTs',
          id: 'n-b-a-top-shots-n-f-ts',
          level: '2',
          text: 'NBA Top Shots NFTs',
        },
        {
          html: 'How to Buy NBA Top Shots NFT',
          id: 'how-to-buy-n-b-a-top-shots-n-f-t',
          level: '2',
          text: 'How to Buy NBA Top Shots NFT',
        },
        {
          html: 'Best Crypto Wallets',
          id: 'best-crypto-wallets',
          level: '2',
          text: 'Best Crypto Wallets',
        },
        {
          html: 'Best Cryptocurrency Exchange Platforms',
          id: 'best-cryptocurrency-exchange-platforms',
          level: '2',
          text: 'Best Cryptocurrency Exchange Platforms',
        },
        {
          html: 'Current Crypto Prices',
          id: 'current-crypto-prices',
          level: '2',
          text: 'Current Crypto Prices',
        },
        {
          html: 'NBA Top Shots or Traditional Cards?',
          id: 'n-b-a-top-shots-or-traditional-cards',
          level: '2',
          text: 'NBA Top Shots or Traditional Cards?',
        },
        {
          html: 'Frequently Asked Questions',
          id: 'frequently-asked-questions',
          level: '2',
          text: 'Frequently Asked Questions',
        },
      ],
      innerBlocks: [],
      innerContent: [
        '\n<div class="wp-block-advanced-gutenberg-blocks-summary"><p class="wp-block-advanced-gutenberg-blocks-summary__title">Contents</p><div class="wp-block-advanced-gutenberg-blocks-summary__fold"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg></div><ul role="directory" class="wp-block-advanced-gutenberg-blocks-summary__list"><li><a href="#nba-top-shots-nfts">NBA Top Shots NFTs</a><ul></ul></li><li><a href="#how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</a><ul></ul></li><li><a href="#best-crypto-wallets">Best Crypto Wallets</a><ul><li><a href="#best-software-wallet-dapper">Best Software Wallet: Dapper</a><ul></ul></li><li><a href="#best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</a><ul></ul></li></ul></li><li><a href="#best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</a><ul></ul></li><li><a href="#current-crypto-prices">Current Crypto Prices</a><ul></ul></li><li><a href="#nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</a><ul></ul></li><li><a href="#frequently-asked-questions">Frequently Asked Questions</a><ul></ul></li></ul></div>\n',
      ],
      innerHTML:
        '\n<div class="wp-block-advanced-gutenberg-blocks-summary"><p class="wp-block-advanced-gutenberg-blocks-summary__title">Contents</p><div class="wp-block-advanced-gutenberg-blocks-summary__fold"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg></div><ul role="directory" class="wp-block-advanced-gutenberg-blocks-summary__list"><li><a href="#nba-top-shots-nfts">NBA Top Shots NFTs</a><ul></ul></li><li><a href="#how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</a><ul></ul></li><li><a href="#best-crypto-wallets">Best Crypto Wallets</a><ul><li><a href="#best-software-wallet-dapper">Best Software Wallet: Dapper</a><ul></ul></li><li><a href="#best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</a><ul></ul></li></ul></li><li><a href="#best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</a><ul></ul></li><li><a href="#current-crypto-prices">Current Crypto Prices</a><ul></ul></li><li><a href="#nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</a><ul></ul></li><li><a href="#frequently-asked-questions">Frequently Asked Questions</a><ul></ul></li></ul></div>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="nba-top-shots-nfts">NBA Top Shots NFTs</h2>\n'],
      innerHTML: '\n<h2 id="nba-top-shots-nfts">NBA Top Shots NFTs</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The NBA Top Shots are digital collectibles that may be the next evolution of trading cards. However, these collectibles hardly resemble a physical NBA trading card. Top Shots main feature is player highlight video clips.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>The NBA Top Shots are digital collectibles that may be the next evolution of trading cards. However, these collectibles hardly resemble a physical NBA trading card. Top Shots main feature is player highlight video clips.&nbsp;</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>For example, the Lebron James Dunk Top Shot features Lebron James dunking on the Houston Rockets. This Top Shot is particularly sought after and extremely limited –– the highest sold edition sold for north of $200,000. Other Top Shots are as cheap as $5, and you can view the transaction history for each collectible to get an idea of how its value has changed over time.</p>\n',
      ],
      innerHTML:
        '\n<p>For example, the Lebron James Dunk Top Shot features Lebron James dunking on the Houston Rockets. This Top Shot is particularly sought after and extremely limited –– the highest sold edition sold for north of $200,000. Other Top Shots are as cheap as $5, and you can view the transaction history for each collectible to get an idea of how its value has changed over time.</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</h2>\n'],
      innerHTML: '\n<h2 id="how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</h2>\n',
    },
    {
      attrs: {
        defaultDurationText: 'Time needed:',
        steps: [
          {
            id: 'how-to-step-1621024341417',
            jsonName: 'Make an NBA Top Shot account. ',
            jsonText:
              'To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.<br/><br/>Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. ',
            name: ['Make an NBA Top Shot account. '],
            text: [
              'To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.',
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              'Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. ',
            ],
          },
          {
            id: 'how-to-step-1621024360584',
            jsonName: 'Buy a wallet (optional).',
            jsonText:
              'If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.',
            name: ['Buy a wallet (optional).'],
            text: [
              'If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.',
            ],
          },
          {
            id: 'how-to-step-1621024385027',
            jsonName: 'Buy a piece from the collection.',
            jsonText:
              'You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.<br/><br/>NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.<br/><br/>If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.',
            name: ['Buy a piece from the collection.'],
            text: [
              'You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.',
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              'NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.',
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              'If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.',
            ],
          },
        ],
      },
      blockName: 'yoast/how-to-block',
      innerBlocks: [],
      innerContent: [
        '\n<div class="schema-how-to wp-block-yoast-how-to-block"><p class="schema-how-to-description"></p> <ol class="schema-how-to-steps"><li class="schema-how-to-step" id="how-to-step-1621024341417"><strong class="schema-how-to-step-name">Make an NBA Top Shot account. </strong> <p class="schema-how-to-step-text">To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.<br/><br/>Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. </p> </li><li class="schema-how-to-step" id="how-to-step-1621024360584"><strong class="schema-how-to-step-name">Buy a wallet (optional).</strong> <p class="schema-how-to-step-text">If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.</p> </li><li class="schema-how-to-step" id="how-to-step-1621024385027"><strong class="schema-how-to-step-name">Buy a piece from the collection.</strong> <p class="schema-how-to-step-text">You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.<br/><br/>NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.<br/><br/>If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.</p> </li></ol></div>\n',
      ],
      innerHTML:
        '\n<div class="schema-how-to wp-block-yoast-how-to-block"><p class="schema-how-to-description"></p> <ol class="schema-how-to-steps"><li class="schema-how-to-step" id="how-to-step-1621024341417"><strong class="schema-how-to-step-name">Make an NBA Top Shot account. </strong> <p class="schema-how-to-step-text">To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.<br/><br/>Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. </p> </li><li class="schema-how-to-step" id="how-to-step-1621024360584"><strong class="schema-how-to-step-name">Buy a wallet (optional).</strong> <p class="schema-how-to-step-text">If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.</p> </li><li class="schema-how-to-step" id="how-to-step-1621024385027"><strong class="schema-how-to-step-name">Buy a piece from the collection.</strong> <p class="schema-how-to-step-text">You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.<br/><br/>NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.<br/><br/>If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.</p> </li></ol></div>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="best-crypto-wallets">Best Crypto Wallets</h2>\n'],
      innerHTML: '\n<h2 id="best-crypto-wallets">Best Crypto Wallets</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: ['\n<p>Here are the best software and hardware wallets to store your NBA Top Shot NFTs.</p>\n'],
      innerHTML: '\n<p>Here are the best software and hardware wallets to store your NBA Top Shot NFTs.</p>\n',
    },
    {
      attrs: {
        level: 3,
      },
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h3 id="best-software-wallet-dapper">Best Software Wallet: Dapper</h3>\n'],
      innerHTML: '\n<h3 id="best-software-wallet-dapper">Best Software Wallet: Dapper</h3>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Dapper has its own unique software wallet you can store your NFTs on securely. The application is free to use, and you can create a new software wallet in just a few minutes. Since this software wallet works specifically for the Flow blockchain, you can’t store Ethereum-based NFTs in this wallet. If you try to send other types of NFTs to your Dapper wallet, your collectibles will be lost in the blockchain transaction.</p>\n',
      ],
      innerHTML:
        '\n<p>Dapper has its own unique software wallet you can store your NFTs on securely. The application is free to use, and you can create a new software wallet in just a few minutes. Since this software wallet works specifically for the Flow blockchain, you can’t store Ethereum-based NFTs in this wallet. If you try to send other types of NFTs to your Dapper wallet, your collectibles will be lost in the blockchain transaction.</p>\n',
    },
    {
      attrs: {
        align: 'right',
        data: {
          _cta_button_text: 'field_5cb4979c88b63',
          _hide_attributes: 'hide_attributes',
          _layout: 'field_5cbf2ec8e9b44',
          _placement_identifier: 'placement_identifier',
          _product: 'field_5978cdb7f1280',
          _product_link_type: 'field_5cb4bc4c7821f',
          _show_best_for: 'field_5c7d671aacc4e',
          _show_commissions: 'field_5c7d66f8acc4d',
          _show_company_name: 'field_5cb4bb4064ecd',
          _show_cons: 'field_5c7d6744acc50',
          _show_pros: 'field_5c7d6731acc4f',
          _show_star_rating: 'field_5cb4bd781b5f6',
          cta_button_text: '',
          hide_attributes: '0',
          layout: 'auto',
          placement_identifier: {
            placement_id: 23219,
          },
          product: 99401,
          product_link_type: 'default',
          show_best_for: '0',
          show_commissions: '0',
          show_company_name: '0',
          show_cons: '0',
          show_pros: '0',
          show_star_rating: '1',
        },
        id: 'block_6053b3d9f7395',
        mode: 'preview',
        name: 'acf/product-review-card',
      },
      blockName: 'acf/product-review-card',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
      product: {
        best_for: 'ERC-20 tokens',
        details: {
          best_for: ['ERC-20 tokens', 'All experience levels'],
          cons: ['Can be quite pricey'],
          desc: '<p><span style="font-weight: 400;">Launched in 2014, Ledger has transformed into a fast-paced, growing company developing infrastructure and security solutions for cryptocurrencies as well as blockchain applications for companies and individuals. Born in Paris, the company has since expanded to more than 130 employees in France and San Francisco.</span></p>\n<p><span style="font-weight: 400;">With 1,500,000 Ledger wallets already sold in 165 countries, the company aims at securing the new disruptive class of crypto assets. Ledger has developed a distinctive operating system called BOLOS, which it integrates to a secure chip for its line of wallets. So far, Ledger takes pride in being the only market player to provide this technology.</span></p>\n',
          pros: [
            'Easy to set up and use',
            'Supports more than 1,500 different digital assets',
            'Tamper proof',
            'Portable',
            'Long-lasting battery',
            'Bluetooth connectivity features',
          ],
        },
        id: 99401,
        image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/02/12104446/ledger.png',
        link: 'https://www.benzinga.com/go/ledger-hardware-wallet',
        name: 'Ledger Hardware Wallet',
        rating: 5,
        review: 'https://www.benzinga.com/money/ledger-wallet-review/',
      },
    },
    {
      attrs: {
        level: 3,
      },
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h3 id="best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</h3>\n'],
      innerHTML: '\n<h3 id="best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</h3>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The safest way to store your NFTs and cryptocurrency is with a hardware wallet. Hardware wallets are physical devices that store your cryptocurrency offline, making it impossible for your assets to be stolen by online hackers.</p>\n',
      ],
      innerHTML:
        '\n<p>The safest way to store your NFTs and cryptocurrency is with a hardware wallet. Hardware wallets are physical devices that store your cryptocurrency offline, making it impossible for your assets to be stolen by online hackers.</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Ledger is one of the most well known hardware wallet producers on the market. They offer a few products, most notably the Ledger Nano S and the Ledger Nano X. Both these hardware wallets serve the same function, but the Nano X is Ledger’s more premium wallet. </p>\n',
      ],
      innerHTML:
        '\n<p>Ledger is one of the most well known hardware wallet producers on the market. They offer a few products, most notably the Ledger Nano S and the Ledger Nano X. Both these hardware wallets serve the same function, but the Nano X is Ledger’s more premium wallet. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The Ledger Nano S comes in at an affordable price for most crypto investors, coming in at just over $50. If you opt for the Ledger Nano X, expect to pay north of $100.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>The Ledger Nano S comes in at an affordable price for most crypto investors, coming in at just over $50. If you opt for the Ledger Nano X, expect to pay north of $100.&nbsp;</p>\n',
    },
    {
      attrs: {
        height: 20,
      },
      blockName: 'core/spacer',
      innerBlocks: [],
      innerContent: ['\n<div style="height:20px" aria-hidden="true" class="wp-block-spacer"></div>\n'],
      innerHTML: '\n<div style="height:20px" aria-hidden="true" class="wp-block-spacer"></div>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</h2>\n'],
      innerHTML: '\n<h2 id="best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Cryptocurrency exchanges let you purchase crypto using your bank account. In order to buy Ethereum, Bitcoin or Bitcoin Cash, you’ll need to use a cryptocurrency exchange. Alternatively, if you know someone who owns cryptocurrency, you could buy it directly from them and have the seller send the crypto to your cryptocurrency wallet.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>Cryptocurrency exchanges let you purchase crypto using your bank account. In order to buy Ethereum, Bitcoin or Bitcoin Cash, you’ll need to use a cryptocurrency exchange. Alternatively, if you know someone who owns cryptocurrency, you could buy it directly from them and have the seller send the crypto to your cryptocurrency wallet.&nbsp;</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Some popular exchanges that make it easy to buy and sell cryptocurrency are Gemini, Coinbase and eToro. </p>\n',
      ],
      innerHTML:
        '\n<p>Some popular exchanges that make it easy to buy and sell cryptocurrency are Gemini, Coinbase and eToro. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Coinbase is especially secure. It stores 98% of investors funds in a hardware wallet, leaving the other 2% on the exchange for liquidity. These exchanges all have easy to use interfaces and support all 3 of the cryptocurrencies that NBA Top Shots accepts.</p>\n',
      ],
      innerHTML:
        '\n<p>Coinbase is especially secure. It stores 98% of investors funds in a hardware wallet, leaving the other 2% on the exchange for liquidity. These exchanges all have easy to use interfaces and support all 3 of the cryptocurrencies that NBA Top Shots accepts.</p>\n',
    },
    {
      attrs: {
        data: {
          _cta_placeholder_type: 'cta_placeholder_type',
          _default_cta: 'default_cta',
          cta_placeholder_type: 'compare-products-placement',
          default_cta: '',
        },
        id: 'block_6053b403f7396',
        mode: 'edit',
        name: 'acf/cta-placeholder',
      },
      blockName: 'acf/cta-placeholder',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="current-crypto-prices">Current Crypto Prices</h2>\n'],
      innerHTML: '\n<h2 id="current-crypto-prices">Current Crypto Prices</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Non-fungible tokens have gained popularity alongside the current cryptocurrency bull market. The entire cryptocurrency market cap has appreciated hundreds of billions of dollars this year alone. </p>\n',
      ],
      innerHTML:
        '\n<p>Non-fungible tokens have gained popularity alongside the current cryptocurrency bull market. The entire cryptocurrency market cap has appreciated hundreds of billions of dollars this year alone. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Typically, large market capitalization cryptos are less volatile than small market cap coins and are regarded as a less risky investment. To get an idea of the cryptocurrency market sentiment, you can monitor how the price of large cryptocurrencies like Bitcoin and Ethereum are moving.</p>\n',
      ],
      innerHTML:
        '\n<p>Typically, large market capitalization cryptos are less volatile than small market cap coins and are regarded as a less risky investment. To get an idea of the cryptocurrency market sentiment, you can monitor how the price of large cryptocurrencies like Bitcoin and Ethereum are moving.</p>\n',
    },
    {
      attrs: {
        data: {
          _coins_number: 'field_coins_number',
          _go_link: 'field_5bbcdcb094037',
          coins_number: '',
          go_link: '',
        },
        id: 'block_6053b41af7397',
        mode: 'preview',
        name: 'acf/cryptocurrencies',
      },
      blockName: 'acf/cryptocurrencies',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</h2>\n'],
      innerHTML: '\n<h2 id="nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Since NBA Top Shots are digital collectibles, they can offer more than traditional trading cards. These collectibles are cube shaped, and each face of the cube has different features. The collectibles feature in-game clips of different basketball players, as well as game records and a picture of the player featured on the card.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>Since NBA Top Shots are digital collectibles, they can offer more than traditional trading cards. These collectibles are cube shaped, and each face of the cube has different features. The collectibles feature in-game clips of different basketball players, as well as game records and a picture of the player featured on the card.&nbsp;</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>If NBA Top Shots replace NBA playing cards in the future, the initial releases will likely be worth a lot of money someday, like rare trading cards from the 1950s. </p>\n',
      ],
      innerHTML:
        '\n<p>If NBA Top Shots replace NBA playing cards in the future, the initial releases will likely be worth a lot of money someday, like rare trading cards from the 1950s. </p>\n',
    },
    {
      attrs: {
        data: {
          _cta_placeholder_type: 'cta_placeholder_type',
          _default_cta: 'default_cta',
          cta_placeholder_type: 'secondary',
          default_cta: '',
        },
        id: 'block_6053b422f7398',
        mode: 'edit',
        name: 'acf/cta-placeholder',
      },
      blockName: 'acf/cta-placeholder',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="frequently-asked-questions">Frequently Asked Questions</h2>\n'],
      innerHTML: '\n<h2 id="frequently-asked-questions">Frequently Asked Questions</h2>\n',
    },
    {
      attrs: {
        data: {
          _questions: 'faq',
          _questions_0_answer: 'faq_answer',
          _questions_0_question: 'faq_question',
          _questions_1_answer: 'faq_answer',
          _questions_1_question: 'faq_question',
          _style_faq: 'field_style_faq',
          questions: 2,
          questions_0_answer:
            '<span style="font-weight: 400;">NBA Top Shot started in October 2020. Since its inception, the company has transacted over $230 million of Top Shots on its website. The company is a joint venture between the NBA and Dapper Labs, the developer of the popular crypto game, CryptoKitties. </span>',
          questions_0_question: 'Q. When did NBA Top Shot start?\r\n',
          questions_1_answer:
            '<span style="font-weight: 400;">Top Shot is a platform where you can buy and sell digital basketball collectibles. It’s powered by the Flow Blockchain made by Dapper Labs, and it uses non-fungible tokens to authenticate its digital collectibles. If a token is non fungible, then each token can hold a distinct value, allowing for collectibles like trading cards to be tokenized on the blockchain.</span>',
          questions_1_question: 'Q. How does Top Shot work?\r\n',
          style_faq: 'default',
        },
        id: 'block_6053b564f7399',
        mode: 'edit',
        name: 'acf/faq',
      },
      blockName: 'acf/faq',
      faq: [
        {
          answer:
            '<span style="font-weight: 400;">NBA Top Shot started in October 2020. Since its inception, the company has transacted over $230 million of Top Shots on its website. The company is a joint venture between the NBA and Dapper Labs, the developer of the popular crypto game, CryptoKitties. </span>',
          question: 'Q. When did NBA Top Shot start?\r\n',
        },
        {
          answer:
            '<span style="font-weight: 400;">Top Shot is a platform where you can buy and sell digital basketball collectibles. It’s powered by the Flow Blockchain made by Dapper Labs, and it uses non-fungible tokens to authenticate its digital collectibles. If a token is non fungible, then each token can hold a distinct value, allowing for collectibles like trading cards to be tokenized on the blockchain.</span>',
          question: 'Q. How does Top Shot work?\r\n',
        },
      ],
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
  ],
  campaigns: {
    compare_partners: {
      blocks: [
        {
          attrs: {
            data: {
              _compare_products: 'block_compare_products',
              _default_open_description: 'default_open_description',
              _show_product_names: 'show_product_names',
              compare_products: ['125386', '154299', '24544', '128031', '93843', '61546'],
              default_open_description: '0',
              show_product_names: '0',
            },
            id: 'block_5ec57711e2d32',
            mode: 'edit',
            name: 'acf/compare-products',
          },
          blockName: 'acf/compare-products',
          innerBlocks: [],
          innerContent: [],
          innerHTML: '',
          products: [
            {
              best_for: 'Low Minimums',
              details: {
                best_for: ['Active traders', 'Intermediate traders'],
                cons: ['Only offers 14 coins'],
                desc: '<p>Webull, founded in 2017, is a mobile app-based brokerage that features commission-free stock and exchange-traded fund (ETF) trading. It’s regulated by the Securities and Exchange Commission (SEC) and the Financial Industry Regulatory Authority (FINRA).</p>\n<p>Webull offers active traders technical indicators, economic calendars, ratings from research agencies, margin trading and short-selling. Webull’s trading platform is designed for intermediate and experienced traders, although beginning traders can also benefit.</p>\n<p>Webull is widely considered one of the best Robinhood alternatives.</p>\n',
                pros: [
                  'No charges to open and maintain an account',
                  'No account maintenance fees or software platform fees',
                  'Intuitive trading platform with technical and fundamental analysis tools',
                ],
              },
              id: 125386,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/20154335/Webull.png',
              link: 'https://www.benzinga.com/go/webull-crypto',
              name: 'Webull Crypto',
              rating: 4,
              review: 'https://www.benzinga.com/money/webull-review/',
            },
            {
              best_for: 'Staking Crypto + Earning Rewards',
              details: {
                best_for: ['Newcomers to the cryptocurrency world', 'Ease of use', 'Trezor integration'],
                cons: ['FTX app not available on the mobile app'],
                desc: '<p><span style="font-weight: 400;">Founded in 2015, </span><b>Exodus</b><span style="font-weight: 400;"> is a multiasset software wallet that removes the geek requirement and keeps design a priority to make </span><a href="https://www.benzinga.com/money/best-cryptocurrency/"><span style="font-weight: 400;">cryptocurrency</span></a><span style="font-weight: 400;"> and digital assets easy for everyone. Available for desktop and mobile, Exodus allows users to secure, manage and exchange cryptocurrencies like </span><a href="https://www.benzinga.com/money/is-bitcoin-a-good-investment/"><span style="font-weight: 400;">Bitcoin</span></a><span style="font-weight: 400;"> (BTC), </span><a href="https://www.benzinga.com/money/is-ethereum-a-good-investment/"><span style="font-weight: 400;">Ethereum</span></a><span style="font-weight: 400;"> (ETH) and more across an industry-leading 10,000-plus asset pairs from a beautiful, easy-to-use wallet. The noncustodial functionality is encrypted locally on users’ own devices, ensuring privacy, security and complete control over their wealth. Exodus is on a mission to empower half the world to exit the traditional finance system by 2030.</span></p>\n',
                pros: [
                  'Free',
                  'Huge selection of cryptocurrencies',
                  'Excellent 24/7 customer support',
                  'No personal info needed',
                ],
              },
              id: 154299,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21155553/Exodus_logo_dark.png',
              link: 'https://www.benzinga.com/go/exodus-wallet',
              name: 'Exodus Wallet',
              rating: 4,
              review: 'https://www.benzinga.com/money/exodus-bitcoin-crypto-wallet-review/',
            },
            {
              best_for: 'Copy Trading',
              details: {
                best_for: [
                  'U.S. based cryptocurrency traders',
                  'Investors looking to CopyTrade other traders',
                  'Simple user interface',
                ],
                cons: ['Only 29 coins available'],
                desc: '<p>eToro, headquartered in Cyprus, England and Israel, has provided forex products and other CFD derivatives to retail clients since 2007. A major eToro plus is its social trading operations, including OpenBook, which allows new clients to copy trade the platform’s best performers. Its social trading features are top notch, but eToro loses points for its lack of tradable currency pairs and underwhelming research and customer service features</p>\n',
                pros: [
                  'Several major cryptocurrencies and altcoins',
                  'Expansive network of social trading features',
                  'Large client base for new traders to imitate',
                ],
              },
              id: 24544,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/19155902/etoro-e1589918475382.png',
              link: 'https://www.benzinga.com/go/etoro',
              name: 'eToro',
              rating: 4,
              review: 'https://www.benzinga.com/money/etoro-review/',
            },
            {
              best_for: 'A Fast Trading Experience',
              details: {
                best_for: [],
                cons: [],
                desc: '',
                pros: [],
              },
              id: 128031,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
              link: 'https://www.benzinga.com/go/uphold-crypto-convertor',
              name: 'Uphold Crypto',
              rating: 4,
              review: 'https://www.benzinga.com/money/uphold-review/',
            },
            {
              best_for: 'New Investors',
              details: {
                best_for: [
                  'New investors looking for a simple mobile and web app',
                  'Day traders looking to use technical analysis tools',
                  'Users looking for a 1-stop-shop to buy, sell and store all of their cryptos',
                ],
                cons: [
                  'Charges both a commission and a convenience fee for users buying and selling through the desktop or mobile app',
                ],
                desc: '<p>Gemini is a cryptocurrency exchange and custodian that offers investors access to over 100 coins and tokens. Founded in the US, Gemini is expanding globally, in particular into Europe and Asia. Offerings include both major cryptocurrency projects like Bitcoin and Ethereum, and smaller altcoins like Orchid and 0x.</p>\n<p><span style="font-weight: 400;">Gemini is 1 of the only brokers with multiple platform options based on skill level. New investors will love the streamlined interface of Gemini’s mobile and web apps, while advanced investors might appreciate all the tools that come with ActiveTrader. </span></p>\n<p><span style="font-weight: 400;">In addition to a host of platform choices, Gemini users also have access to insured hot wallets to store tokens without worrying about digital asset theft. Learn more about what Gemini can do for you in our review.</span></p>\n',
                pros: [
                  'Easy and quick signups — can get started in as little as a 5 minutes',
                  'Multitude of platforms to accommodate traders of all skill levels',
                  'Hot wallets include insurance to protect your from theft and hacking attempts',
                ],
              },
              id: 93843,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/11153952/gemini-large.png',
              link: 'https://www.benzinga.com/go/gemini-crypto',
              name: 'Gemini Crypto',
              rating: 4,
              review: 'https://www.benzinga.com/money/gemini-review/',
            },
            {
              best_for: 'Coinbase Learn',
              details: {
                best_for: [
                  'New cryptocurrency traders',
                  'Cryptocurrency traders interested in major pairs',
                  'Cryptocurrency traders interested in a simple platform',
                ],
                cons: ['Higher fees than competitors'],
                desc: '<p><span style="font-weight: 400;">Coinbase is one of the Internet’s largest cryptocurrency trading platforms. From Bitcoin to Litecoin or Basic Attention Token to Chainlink, Coinbase makes it exceptionally simple to buy and sell major cryptocurrency pairs. </span></p>\n<p><span style="font-weight: 400;">You can even earn cryptocurrency rewards through Coinbase’s unique Coinbase Earn feature. More advanced traders will love the Coinbase Pro platform, which offers more order types and enhanced functionality.</span></p>\n<p><span style="font-weight: 400;">Though Coinbase doesn’t offer the most affordable pricing or the lowest fees, its simple platform is easy enough for complete beginners to master in as little as a single trade. </span></p>\n',
                pros: [
                  'Simple platform is easy to operate',
                  'Comprehensive mobile app mirrors desktop functionality',
                  'Coinbase Earn feature rewards you with crypto for learning about available coins',
                ],
              },
              id: 61546,
              image:
                'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/10/02202252/coinbase-new-2021-logo-FA5145228F-seeklogo.com_.png',
              link: 'https://www.benzinga.com/go/coinbase',
              name: 'Coinbase',
              rating: 4,
              review: 'https://www.benzinga.com/money/coinbase-review/',
            },
          ],
        },
        {
          attrs: [],
          blockName: 'core/paragraph',
          innerBlocks: [],
          innerContent: ['\n<p></p>\n'],
          innerHTML: '\n<p></p>\n',
        },
      ],
      widget: {
        ID: 69884,
        comment_count: '0',
        comment_status: 'closed',
        filter: 'raw',
        guid: 'https://www.benzinga.com/?post_type=widget&#038;p=69884',
        menu_order: 0,
        ping_status: 'closed',
        pinged: '',
        post_author: '60',
        post_content:
          '<!-- wp:acf/compare-products {\n    "id": "block_5ec57711e2d32",\n    "name": "acf\\/compare-products",\n    "data": {\n        "compare_products": [\n            "125386",\n            "154299",\n            "24544",\n            "128031",\n            "93843",\n            "61546"\n        ],\n        "_compare_products": "block_compare_products",\n        "show_product_names": "0",\n        "_show_product_names": "show_product_names",\n        "default_open_description": "0",\n        "_default_open_description": "default_open_description"\n    },\n    "mode": "edit"\n} /-->\n\n<!-- wp:paragraph -->\n<p></p>\n<!-- /wp:paragraph -->',
        post_content_filtered: '',
        post_date: '2020-05-20 14:32:46',
        post_date_gmt: '2020-05-20 18:32:46',
        post_excerpt: '',
        post_mime_type: '',
        post_modified: '2022-03-01 17:07:28',
        post_modified_gmt: '2022-03-01 22:07:28',
        post_name: 'compare-brokers-cryptocurrency',
        post_parent: 0,
        post_password: '',
        post_status: 'publish',
        post_title: 'Compare Brokers - Cryptocurrency',
        post_type: 'widget',
        to_ping: '',
      },
    },
    floating: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      display_y_position: 400,
      has_targeting: true,
      placements: [
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description:
              'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
            cta_text: 'claim now',
            cta_title: 'Benzinga x Wealthsimple',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure: '',
            href: 'https://www.benzinga.com/go/wealthsimple-crypto',
            image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'Wealthsimple',
            placement_slug: 'wealthsimple-crypto',
            product_id: null,
            url: 'https://www.benzinga.com/go/wealthsimple-crypto',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
          },
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
    popup: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      delay: 10000,
      has_targeting: true,
      placements: [
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
            cta_text: 'Claim Now',
            cta_title: 'Earn 12.3% APY on Crypto! ',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure:
              'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
            href: 'https://www.benzinga.com/go/hodlnaut',
            image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'Hodlnaut',
            placement_slug: 'hodlnaut',
            product_id: null,
            url: 'https://www.benzinga.com/go/hodlnaut',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
          },
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
    primary: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      has_targeting: true,
      placeholder_type: 'primary',
      placements: [
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description:
              'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
            cta_text: 'Get Started',
            cta_title: 'Get $100,000 to practice your trading skills',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure:
              'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
            href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
            image_url:
              'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'eToro',
            placement_slug: 'etoro-crypto-non-us',
            product_id: null,
            url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
          },
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
    secondary: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      has_targeting: true,
      placeholder_type: 'secondary',
      placements: [
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description:
              'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
            cta_text: 'Get Started',
            cta_title: 'Earn Crypto Rewards',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure: '',
            href: 'https://www.benzinga.com/go/exodus-wallet',
            image_url:
              'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'Exodus Wallet',
            placement_slug: 'exodus',
            product_id: null,
            url: 'https://www.benzinga.com/go/exodus-wallet',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
          },
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
  },
  canonical_link: 'https://www.benzinga.com/money/how-to-buy-nba-top-shots-nft',
  content_footer: {
    blocks: [
      {
        attrs: {
          data: {
            _description: 'field_description',
            _form_id: 'field_form_id',
            _style: 'field_style',
            _title: 'field_title',
            _utm_label: 'field_utm_label',
            description:
              '<ul>\r\n \t<li>Exclusive Crypto Airdrops</li>\r\n \t<li>Altcoin of the Week</li>\r\n \t<li>Insider Interviews</li>\r\n \t<li>News &amp; Show Highlights</li>\r\n \t<li>Completely FREE</li>\r\n</ul>',
            form_id: '6d120c76-8a53-4729-9627-e36a737e2a30',
            style: 'default',
            title: 'The Crypto Rocketship: Weekly Newsletter',
            utm_label: 'Sign Up',
          },
          id: 'block_5fea016510bf8',
          mode: 'edit',
          name: 'acf/newsletter-subscription-box',
        },
        blockName: 'acf/newsletter-subscription-box',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
      },
    ],
    id: 94072,
    title: 'Cryptocurrency Article Footer',
    type: 'footer',
  },
  content_header: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/html',
        innerBlocks: [],
        innerContent: [
          '\n<script src="https://crypto.com/price/static/widget/index.js" id="crypto-widget-script" defer></script>\n<div id="crypto-widget-CoinMarquee" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern" style="height: 190px;"></div>\n\n<style>.header-wrapper{width: 100%;}</style>\n<script>\nif(window.location.href.match(/utm_source=robinhood.com/)) {\n  document.getElementById(\'crypto-widget-script\').remove()\n  document.getElementById(\'crypto-widget-CoinMarquee\').remove()\n  r(() => {\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n  })\n}\n</script>\n',
        ],
        innerHTML:
          '\n<script src="https://crypto.com/price/static/widget/index.js" id="crypto-widget-script" defer></script>\n<div id="crypto-widget-CoinMarquee" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern" style="height: 190px;"></div>\n\n<style>.header-wrapper{width: 100%;}</style>\n<script>\nif(window.location.href.match(/utm_source=robinhood.com/)) {\n  document.getElementById(\'crypto-widget-script\').remove()\n  document.getElementById(\'crypto-widget-CoinMarquee\').remove()\n  r(() => {\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n  })\n}\n</script>\n',
      },
    ],
    id: 145180,
    title: 'Crypto.com Coin Marquee Header',
    type: 'header',
  },
  cornerstone: {
    child_posts: [],
    current_post_id: 103515,
    current_post_title: 'How to Buy NBA Top Shots NFT',
    id: 134276,
    link: '/money/best-nft-investments/',
    parent_id: 101349,
    parent_link: '/money/what-is-a-non-fungible-token-nft/',
    parent_title: 'NFTs',
    title: 'Best NFTs',
  },
  footer: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/heading',
        innerBlocks: [],
        innerContent: ['\n<h2>Methodology</h2>\n'],
        innerHTML: '\n<h2>Methodology</h2>\n',
      },
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p>Benzinga crafted a specific methodology to rank cryptocurrency exchanges and tools. We prioritized platforms based on offerings, pricing and promotions, customer service, mobile app, user experience and benefits, and security.  To see a comprehensive breakdown of our methodology, please visit see our <a href="https://www.benzinga.com/money/investing/benzingas-crypto-methodology/">Cryptocurrency Methodology</a> page.</p>\n',
        ],
        innerHTML:
          '\n<p>Benzinga crafted a specific methodology to rank cryptocurrency exchanges and tools. We prioritized platforms based on offerings, pricing and promotions, customer service, mobile app, user experience and benefits, and security.  To see a comprehensive breakdown of our methodology, please visit see our <a href="https://www.benzinga.com/money/investing/benzingas-crypto-methodology/">Cryptocurrency Methodology</a> page.</p>\n',
      },
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p><em><strong>Disclaimer:</strong> As per the European Securities and Markets Authority (ESMA), the percentage of retail clients losing money on CFD trading must be updated every three months. Please note that eToro’s new results are 67% in regards to retail investor accounts losing money when trading CFDs with eToro. Due to this change, we require you to immediately update all of your eToro related promotions, web properties, and campaigns featuring CFD disclaimers to 67%.</em></p>\n',
        ],
        innerHTML:
          '\n<p><em><strong>Disclaimer:</strong> As per the European Securities and Markets Authority (ESMA), the percentage of retail clients losing money on CFD trading must be updated every three months. Please note that eToro’s new results are 67% in regards to retail investor accounts losing money when trading CFDs with eToro. Due to this change, we require you to immediately update all of your eToro related promotions, web properties, and campaigns featuring CFD disclaimers to 67%.</em></p>\n',
      },
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p><strong><em>This content should not be interpreted as investment advice. Cryptocurrency is a volatile market, do your independent research and only invest what you can afford to lose.</em></strong></p>\n',
        ],
        innerHTML:
          '\n<p><strong><em>This content should not be interpreted as investment advice. Cryptocurrency is a volatile market, do your independent research and only invest what you can afford to lose.</em></strong></p>\n',
      },
    ],
    id: 68346,
    title: 'Cryptocurrency Footer',
    type: 'footer',
  },
  global_footer: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p><strong>Want to advertise with us? <a href="https://advertise.benzinga.com/" target="_blank" rel="noreferrer noopener">Send us a message</a>. </strong></p>\n',
        ],
        innerHTML:
          '\n<p><strong>Want to advertise with us? <a href="https://advertise.benzinga.com/" target="_blank" rel="noreferrer noopener">Send us a message</a>. </strong></p>\n',
      },
    ],
    id: 160497,
    title: 'Advertise With Us',
    type: 'footer',
  },
  id: 103515,
  image:
    'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/03/18161911/basketball-1544370_1920-768x683.jpg',
  meta: {
    author: 'Ryan McNamara',
    description: '',
    image:
      'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/03/18161911/basketball-1544370_1920-768x683.jpg',
    modifiedDate: '2021-08-12T12:11:43.000000Z',
    postId: 103515,
    publishedDate: '2021-05-14T16:35:00.000000Z',
    title: 'How to Buy NBA Top Shots NFT',
  },
  parent: {
    child_posts: [
      {
        id: 148060,
        link: '/money/nft-release-calendar/',
        title: 'NFT Release Calendar',
      },
      {
        id: 104732,
        link: '/money/how-to-buy-cryptopunks-nft/',
        title: 'CryptoPunks NFT',
      },
      {
        id: 104460,
        link: '/money/how-to-buy-music-nfts/',
        title: 'Music NFT',
      },
      {
        id: 103515,
        link: '/money/how-to-buy-nba-top-shots-nft/',
        title: 'NBA Top Shot NFT',
      },
      {
        id: 102824,
        link: '/money/how-to-buy-nfts/',
        title: 'How to buy NFTs',
      },
      {
        id: 150464,
        link: '/money/are-nfts-a-good-investment/',
        title: 'Are NFTS a Good Investment?',
      },
      {
        id: 105474,
        link: '/money/are-nfts-a-scam-or-a-digital-bubble/',
        title: 'Are NFTs a Scam?',
      },
      {
        id: 110150,
        link: '/money/best-nft-related-stocks/',
        title: 'NFT RELATED STOCKS',
      },
    ],
    current_post_id: 134276,
    current_post_title: 'Best NFT Projects in 2022',
    id: 134276,
    link: '/money/best-nft-investments/',
    parent_id: 101349,
    parent_link: '/money/what-is-a-non-fungible-token-nft/',
    parent_title: 'NFTs',
    title: 'Best NFTs',
  },
  sidebar: {
    blocks: [
      {
        attrs: {
          height: 649,
          id: 165344,
          linkDestination: 'custom',
          sizeSlug: 'large',
          width: 325,
        },
        blockName: 'core/image',
        href: 'https://www.benzinga.com/go/celsius-sidebar',
        image: {
          attachment_id: 165344,
          caption: '',
          image_id: 165344,
          sizes: {
            'Multi Rating Pro Thumbnail': {
              height: 100,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-100x100.png',
              width: 100,
            },
            large: {
              height: 1024,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-512x1024.png',
              width: 512,
            },
            medium: {
              height: 300,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-150x300.png',
              width: 150,
            },
            'slideshow-img': {
              height: 600,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-600x600.png',
              width: 600,
            },
            thumbnail: {
              height: 150,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-150x150.png',
              width: 150,
            },
          },
          title: 'CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1',
        },
        innerBlocks: [],
        innerContent: [
          '\n<figure class="wp-block-image size-large is-resized"><a href="https://www.benzinga.com/go/celsius-sidebar"><img src="https://www.benzinga.com/wp-content/uploads/2022/01/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-512x1024.png" alt="" class="wp-image-165344" width="325" height="649"/></a></figure>\n',
        ],
        innerHTML:
          '\n<figure class="wp-block-image size-large is-resized"><a href="https://www.benzinga.com/go/celsius-sidebar"><img src="https://www.benzinga.com/wp-content/uploads/2022/01/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-512x1024.png" alt="" class="wp-image-165344" width="325" height="649"/></a></figure>\n',
      },
      {
        attrs: {
          align: '',
          data: {
            _related_post_style: 'field_related_post_style',
            _related_posts: 'field_5c7e673bead4b',
            _title: 'field_5c7e67175e8bb',
            related_post_style: 'default',
            related_posts: ['96298', '95574', '101349', '105115'],
            title: 'Learn About Cryptocurrency',
          },
          id: 'l3WydAMdT2',
          mode: 'edit',
          name: 'acf/sidebar-related-posts',
        },
        blockName: 'acf/sidebar-related-posts',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
        posts: [
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/6c99a46a209a29b1e26dc24dcb543899?d=mm',
              name: 'Logan Ross',
            },
            date: 'February 16th, 2022',
            description:
              "What is Bitcoin? Does it have a chance at becoming the global reserve currency? Start with Benzinga's guide to learn more today.",
            id: 96298,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/01/15143715/the-company-3338207_1920-768x480.jpg',
            published_at: '2022-02-16T00:37:00.000000Z',
            seotitle: 'What is Bitcoin? • Beginners Guide',
            slug: 'what-is-bitcoin',
            title: 'What is Bitcoin?',
            url: '/money/what-is-bitcoin/',
          },
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/6c99a46a209a29b1e26dc24dcb543899?d=mm',
              name: 'Logan Ross',
            },
            date: 'February 16th, 2022',
            description:
              'Ethereum is a decentralized global computing platform with its own programming language, Solidity, and cryptocurrency, Ether.',
            id: 95574,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/01/12102515/0bo235rhqec-768x512.jpg',
            published_at: '2022-02-16T10:28:00.000000Z',
            seotitle: 'What is Ethereum? • DeFi, Smart Contracts & Eth2',
            slug: 'what-is-ethereum',
            title: 'What is Ethereum?',
            url: '/money/what-is-ethereum/',
          },
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/a601583e19db33fdae89f59b38b6d4cc?d=mm',
              name: 'Chris Katje',
            },
            date: 'January 20th, 2022',
            description:
              'A non-fungible token (NFT) is a digital asset that is unique and indivisible. Learn more about what NFTs are today.',
            id: 101349,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/08/20093407/Screen-Shot-2021-08-20-at-9.34.01-AM.png',
            published_at: '2022-01-20T20:13:00.000000Z',
            seotitle: 'What Are NFTs? • Top Colletions Crypto',
            slug: 'what-is-a-non-fungible-token-nft',
            title: 'What Are NFTs?',
            url: '/money/what-is-a-non-fungible-token-nft/',
          },
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/8acd10f73d8a83ef13da39a2cbe047da?d=mm',
              name: 'Ryan McNamara',
            },
            date: 'March 29th, 2021',
            description:
              'Earning interest on your Ethereum is a great way to grow your cryptocurrency holdings. Find out how to earn interest on your Ethereum in 4 easy steps.',
            id: 105115,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/03/29142306/0bo235rhqec-1-768x512.jpg',
            published_at: '2021-03-29T14:36:35.000000Z',
            seotitle: '',
            slug: 'how-to-earn-interest-on-ethereum',
            title: 'How to Earn Interest on Ethereum',
            url: '/money/how-to-earn-interest-on-ethereum/',
          },
        ],
      },
      {
        attrs: {
          data: {
            _description_visible: 'field_description_visible',
            _header_see_more_link: 'field_header_see_more_link',
            _header_see_more_text: 'field_header_see_more_text',
            _news_exclude_authors: 'field_news_exclude_authors',
            _news_feed_mode: 'field_news_feed_mode',
            _news_feed_parsely_author: 'field_news_feed_parsely_author',
            _news_feed_parsely_category: 'field_news_feed_parsely_category',
            _news_feed_parsely_content: 'field_news_feed_parsely_content',
            _news_feed_parsely_days: 'field_news_feed_parsely_days',
            _news_feed_parsely_limit: 'field_news_feed_parsely_limit',
            _news_feed_parsely_section: 'field_news_feed_parsely_section',
            _news_feed_parsely_tag: 'field_news_feed_parsely_tag',
            _news_feed_primary_header: 'field_news_feed_primary_header',
            _news_feed_style: 'field_news_feed_style',
            _news_feed_type: 'field_news_feed_type',
            _show_newsletter_block: 'field_show_newsletter_block',
            _thumbnail_hidden: 'field_thumbnail_hidden',
            _title: 'field_title',
            description_visible: '1',
            header_see_more_link: '',
            header_see_more_text: '',
            news_exclude_authors: '',
            news_feed_mode: 'default',
            news_feed_parsely_author: '',
            news_feed_parsely_category: 'Cryptocurrency',
            news_feed_parsely_content: 'top-posts',
            news_feed_parsely_days: '1',
            news_feed_parsely_limit: '5',
            news_feed_parsely_section: '',
            news_feed_parsely_tag: '',
            news_feed_primary_header: '0',
            news_feed_style: 'rated',
            news_feed_type: 'parsely',
            show_newsletter_block: '0',
            thumbnail_hidden: '0',
            title: 'Top Cryptocurrency News',
          },
          id: 'block_60612cba1562e',
          mode: 'edit',
          name: 'acf/news-feed',
        },
        blockName: 'acf/news-feed',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
        top_posts: [
          {
            author: 'Samyuktha Sriram',
            authors: ['Samyuktha Sriram'],
            image_url:
              'https://cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/k_7.jpeg?width=720',
            link: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26053893/bye-bye-bitcoin-rich-dad-poor-dad-author-sees-us-seizing-all-crypto-after-bidens-executive?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-09T03:12:34',
            section: 'Cryptocurrency',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Cryptocurrency',
              'category: General',
              'category: Government',
              'category: Markets',
              'category: News',
              'category: Politics',
              'category: Regulations',
              'pageType: NewsArticle',
              'parsely_smart:entity:Bitcoin',
              'parsely_smart:entity:Cryptocurrency',
              'parsely_smart:entity:Ethereum',
              'parsely_smart:entity:Hedge (finance)',
              'parsely_smart:entity:Rich Dad Poor Dad',
              'parsely_smart:entity:Robert Kiyosaki',
              'parsely_smart:iab:Law, Gov’t & Politics',
              'parsely_smart:iab:Legal Issues',
              'parsely_smart:iab:Technology',
              'symbol: $BTC',
              'symbol: $ETH',
              'tag: Bitcoin',
              'tag: Ethereum',
              'tag: Joe Biden',
              'tag: Robert Kiyosaki',
            ],
            thumb_url_medium:
              'https://images.parsely.com/p4GNRlE6KuEW700zfI_dh612TkM=/85x85/smart/https%3A//cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/k_7.jpeg%3Fwidth%3D720',
            title:
              "Bye-Bye Bitcoin? 'Rich Dad Poor Dad' Author Sees US Seizing All Crypto After Biden's Executive Order | Benzinga",
            url: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26053893/bye-bye-bitcoin-rich-dad-poor-dad-author-sees-us-seizing-all-crypto-after-bidens-executive?itm_source=parsely-api',
          },
          {
            author: 'Nina Zdinjak',
            authors: ['Nina Zdinjak'],
            image_url:
              'https://cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/15_15.png?width=720',
            link: 'https://www.benzinga.com/markets/cannabis/22/03/26096494/this-cannabis-stock-has-outperformed-apple-netflix-facebook-and-amazon?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-11T14:08:40',
            section: 'Cannabis',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Cannabis',
              'category: Markets',
              'category: News',
              'category: Small Cap',
              'pageType: NewsArticle',
              'parsely_smart:entity:Agriculture',
              'parsely_smart:entity:Amazon (company)',
              'parsely_smart:entity:Apple Inc.',
              'parsely_smart:entity:E-commerce',
              'parsely_smart:entity:Meta Platforms',
              'parsely_smart:entity:Netflix',
              'parsely_smart:iab:Agriculture',
              'parsely_smart:iab:Business',
              'symbol: AAPL',
              'symbol: AMZN',
              'symbol: FB',
              'symbol: GRWG',
              'symbol: NFLX',
              'tag: cannabis stocks',
              'tag: weed stocks performance',
            ],
            thumb_url_medium:
              'https://images.parsely.com/vf9kpTkTuTY3Ao9QuQ7VXKeNkbg=/85x85/smart/https%3A//cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/15_15.png%3Fwidth%3D720',
            title: 'This Cannabis Stock Has Outperformed Apple, Netflix, Facebook And Amazon | Benzinga',
            url: 'https://www.benzinga.com/markets/cannabis/22/03/26096494/this-cannabis-stock-has-outperformed-apple-netflix-facebook-and-amazon?itm_source=parsely-api',
          },
          {
            author: 'Chris Katje',
            authors: ['Chris Katje'],
            image_url:
              'https://cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/1600px-mtg_first_day.jpg',
            link: 'https://www.benzinga.com/news/22/03/26063227/members-of-congress-buy-energy-defense-stocks-prior-to-russian-invasion-of-ukraine-who-they-are-what?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-09T16:04:58',
            section: 'News',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: General',
              'category: News',
              'category: Politics',
              'pageType: NewsArticle',
              'parsely_smart:entity:Chevron Corporation',
              'parsely_smart:entity:Lockheed Martin',
              'parsely_smart:entity:Marjorie Taylor Greene',
              'parsely_smart:iab:Business',
              'parsely_smart:iab:Government',
              'parsely_smart:iab:Law, Gov’t & Politics',
              'symbol: CVX',
              'symbol: ENLC',
              'symbol: ET',
              'symbol: LMT',
              'symbol: NEE',
              'symbol: PAA',
              'symbol: PPL',
              'symbol: PSX',
              'symbol: SPY',
              'symbol: XLE',
              'tag: Alexandria Ocasio-Cortez',
              'tag: Congress',
              'tag: Congress trading',
              'tag: Ilhan Omar',
              'tag: Marjorie Taylor Greene',
              'tag: Mark Green',
              'tag: Robert Wittman',
              'tag: Russia',
              'tag: Russia-Ukraine Conflict',
              'tag: Ukraine',
              'tag: Unusual Whales',
              'tag: UnusualWhales',
              'tag: Virginia Foxx',
              'tag: defense stocks',
              'tag: energy stocks',
              'tag: oil stocks',
            ],
            thumb_url_medium:
              'https://images.parsely.com/RB9ZMnlw1jXRD8dJXvhBxLtZfL4=/85x85/smart/https%3A//cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/1600px-mtg_first_day.jpg',
            title:
              'SPDR S&P 500 ETF (ETF:SPY), Chevron Corporation (NYSE:CVX) - Members Of Congress Buy Energy, Defense ...',
            url: 'https://www.benzinga.com/news/22/03/26063227/members-of-congress-buy-energy-defense-stocks-prior-to-russian-invasion-of-ukraine-who-they-are-what?itm_source=parsely-api',
          },
          {
            author: 'Rachit Vats',
            authors: ['Rachit Vats'],
            image_url:
              'https://cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/es8_es6_ec6.jpg',
            link: 'https://www.benzinga.com/news/22/03/26094770/why-rumors-of-nio-partnering-with-warren-buffett-backed-byd-are-resurfacing?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-11T04:57:52',
            section: 'News',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Media',
              'category: News',
              'category: Rumors',
              'category: Tech',
              'pageType: NewsArticle',
              'parsely_smart:entity:Automotive industry in China',
              'parsely_smart:entity:BYD Auto',
              'parsely_smart:entity:JAC Motors',
              'parsely_smart:entity:NIO (car company)',
              'parsely_smart:entity:Tesla, Inc.',
              'parsely_smart:entity:XPeng',
              'parsely_smart:iab:Automotive',
              'parsely_smart:iab:Technology',
              'symbol: BYDDY',
              'symbol: NIO',
              'symbol: TSLA',
              'symbol: XPEV',
              'tag: NIO House',
              'tag: Wang Chuanfu',
              'tag: Warren Buffett',
              'tag: William Li',
            ],
            thumb_url_medium:
              'https://images.parsely.com/axMFB-R1usETnaDgviaxTJgShNg=/85x85/smart/https%3A//cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/es8_es6_ec6.jpg',
            title: 'NIO Inc. (NYSE:NIO), BYD COMPANY LTD ADR (BYDDY) - Why Rumors Of Nio Partnering With Warren ...',
            url: 'https://www.benzinga.com/news/22/03/26094770/why-rumors-of-nio-partnering-with-warren-buffett-backed-byd-are-resurfacing?itm_source=parsely-api',
          },
          {
            author: 'Shivdeep Dhaliwal',
            authors: ['Shivdeep Dhaliwal'],
            image_url:
              'https://cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/executium-8xo9gqaamzc-unsplash_1_10.jpg?width=720',
            link: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26096425/dogecoin-shows-signs-of-coming-back-alive-could-the-love-from-amc-be-a-game-changer?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-11T10:10:39',
            section: 'Cryptocurrency',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Cryptocurrency',
              'category: Markets',
              'category: Movers',
              'category: News',
              'category: Trading Ideas',
              'pageType: NewsArticle',
              'parsely_smart:entity:Bitcoin',
              'parsely_smart:entity:Cryptocurrency',
              'parsely_smart:entity:Dogecoin',
              'parsely_smart:iab:Business',
              'parsely_smart:iab:Law, Gov’t & Politics',
              'parsely_smart:iab:Technology',
              'symbol: $DOGE',
              'symbol: AMC',
              'tag: Meme Coins',
              'tag: dogecoin',
            ],
            thumb_url_medium:
              'https://images.parsely.com/_F5Qnj1_u9OlcT_uRw0Gcp33Di4=/85x85/smart/https%3A//cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/executium-8xo9gqaamzc-unsplash_1_10.jpg%3Fwidth%3D720',
            title: 'Dogecoin Shows Signs Of Coming Back Alive: Could The Love From AMC Be A Game Changer? | Benzinga',
            url: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26096425/dogecoin-shows-signs-of-coming-back-alive-could-the-love-from-amc-be-a-game-changer?itm_source=parsely-api',
          },
        ],
      },
      {
        attrs: {
          align: '',
          data: {
            _default_widget: 'default_widget',
            default_widget: 94647,
          },
          id: 'block_5e6015e022762',
          mode: 'edit',
          name: 'acf/page-sidebar-placement',
        },
        blockName: 'acf/page-sidebar-placement',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
      },
      {
        attrs: [],
        blockName: 'core/html',
        innerBlocks: [],
        innerContent: [
          '\n<div id="crypto-widget-CoinList" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern"></div>\n',
        ],
        innerHTML:
          '\n<div id="crypto-widget-CoinList" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern"></div>\n',
      },
    ],
    id: 59458,
    slug: 'cryptocurrency-sidebar',
    title: 'Cryptocurrency /Money Sidebar',
    type: 'sidebar',
  },
  sidebar_placement: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/html',
        innerBlocks: [],
        innerContent: [
          '\n<div style="width:300px"><a class="twitter-timeline" href="https://twitter.com/ALPublicHealth?ref_src=twsrc%5Etfw">Tweets by ALPublicHealth</a> </div>\n<script async="" src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>\n',
        ],
        innerHTML:
          '\n<div style="width:300px"><a class="twitter-timeline" href="https://twitter.com/ALPublicHealth?ref_src=twsrc%5Etfw">Tweets by ALPublicHealth</a> </div>\n<script async="" src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>\n',
      },
    ],
    id: 66025,
    title: 'ALPublicHealth Twitter Timeline',
    type: 'widget',
  },
  slug: 'how-to-buy-nba-top-shots-nft',
  title: 'How to Buy NBA Top Shots NFT',
};
